import React from "react";
export const criminal = () => {
  return (
    <div className="opinion-wrap">
      <h1>中华人民共和国刑法</h1>
      <div className="text-cont">
        <br />
        <br />
        第一编　总则
        <br />
        <br />
        第一章　刑法的任务、基本原则和适用范围
        <br />
        <br />
        　　 <br />
        <br />
        第一条　为了惩罚犯罪，保护人民，根据宪法，结合我国同犯罪作斗争的具体经验及实际情况，制定本法。
        　　 <br />
        <br />
        第二条　中华人民共和国刑法的任务，是用刑罚同一切犯罪行为作斗争，以保卫国家安全，保卫人民民主专政的政权和社会主义制度，保护国有财产和劳动群众集体所有的财产，保护公民私人所有的财产，保护公民的人身权利、民主权利和其他权利，维护社会秩序、经济秩序，保障社会主义建设事业的顺利进行。
        　　 <br />
        <br />
        第三条　法律明文规定为犯罪行为的，依照法律定罪处刑；法律没有明文规定为犯罪行为的，不得定罪处刑。
        　　 <br />
        <br />
        第四条　对任何人犯罪，在适用法律上一律平等。不允许任何人有超越法律的特权。
        　　 <br />
        <br />
        第五条　刑罚的轻重，应当与犯罪分子所犯罪行和承担的刑事责任相适应。 　　{" "}
        <br />
        <br />
        第六条　凡在中华人民共和国领域内犯罪的，除法律有特别规定的以外，都适用本法。
        　　凡在中华人民共和国船舶或者航空器内犯罪的，也适用本法。
        　　犯罪的行为或者结果有一项发生在中华人民共和国领域内的，就认为是在中华人民共和国领域内犯罪。
        　　 <br />
        <br />
        第七条　中华人民共和国公民在中华人民共和国领域外犯本法规定之罪的，适用本法，但是按本法规定的最高刑为三年以下有期徒刑的，可以不予追究。
        　　中华人民共和国国家工作人员和军人在中华人民共和国领域外犯本法规定之罪的，适用本法。
        　　 <br />
        <br />
        第八条　外国人在中华人民共和国领域外对中华人民共和国国家或者公民犯罪，而按本法规定的最低刑为三年以上有期徒刑的，可以适用本法，但是按照犯罪地的法律不受处罚的除外。
        　　 <br />
        <br />
        第九条　对于中华人民共和国缔结或者参加的国际条约所规定的罪行，中华人民共和国在所承担条约义务的范围内行使刑事管辖权的，适用本法。
        　　 <br />
        <br />
        第十条　凡在中华人民共和国领域外犯罪，依照本法应当负刑事责任的，虽然经过外国审判，仍然可以依照本法追究，但是在外国已经受过刑罚处罚的，可以免除或者减轻处罚。
        　　 <br />
        <br />
        第十一条　享有外交特权和豁免权的外国人的刑事责任，通过外交途径解决。
        　　 <br />
        <br />
        第十二条　中华人民共和国成立以后本法施行以前的行为，如果当时的法律不认为是犯罪的，适用当时的法律；如果当时的法律认为是犯罪的，依照本法总则第四章第八节的规定应当追诉的，按照当时的法律追究刑事责任，但是如果本法不认为是犯罪或者处刑较轻的，适用本法。
        　　本法施行以前，依照当时的法律已经作出的生效判决，继续有效。
        <br />
        <br />
        第二章　犯罪 <br />
        <br />
        第一节　犯罪和刑事责任 　　 <br />
        <br />
        第十三条　一切危害国家主权、领土完整和安全，分裂国家、颠覆人民民主专政的政权和推翻社会主义制度，破坏社会秩序和经济秩序，侵犯国有财产或者劳动群众集体所有的财产，侵犯公民私人所有的财产，侵犯公民的人身权利、民主权利和其他权利，以及其他危害社会的行为，依照法律应当受刑罚处罚的，都是犯罪，但是情节显著轻微危害不大的，不认为是犯罪。
        　　 <br />
        <br />
        第十四条　明知自己的行为会发生危害社会的结果，并且希望或者放任这种结果发生，因而构成犯罪的，是故意犯罪。
        　　故意犯罪，应当负刑事责任。 　　 <br />
        <br />
        第十五条　应当预见自己的行为可能发生危害社会的结果，因为疏忽大意而没有预见，或者已经预见而轻信能够避免，以致发生这种结果的，是过失犯罪。
        　　过失犯罪，法律有规定的才负刑事责任。 　　 <br />
        <br />
        第十六条　行为在客观上虽然造成了损害结果，但是不是出于故意或者过失，而是由于不能抗拒或者不能预见的原因所引起的，不是犯罪。
        　　 <br />
        <br />
        第十七条　已满十六周岁的人犯罪，应当负刑事责任。
        　　已满十四周岁不满十六周岁的人，犯故意杀人、故意伤害致人重伤或者死亡、强奸、抢劫、贩卖毒品、放火、爆炸、投毒罪的，应当负刑事责任。
        　　已满十四周岁不满十八周岁的人犯罪，应当从轻或者减轻处罚。
        　　因不满十六周岁不予刑事处罚的，责令他的家长或者监护人加以管教；在必要的时候，也可以由政府收容教养。
        　　 <br />
        <br />
        第十八条　精神病人在不能辨认或者不能控制自己行为的时候造成危害结果，经法定程序鉴定确认的，不负刑事责任，但是应当责令他的家属或者监护人严加看管和医疗；在必要的时候，由政府强制医疗。
        　　间歇性的精神病人在精神正常的时候犯罪，应当负刑事责任。
        　　尚未完全丧失辨认或者控制自己行为能力的精神病人犯罪的，应当负刑事责任，但是可以从轻或者减轻处罚。
        　　醉酒的人犯罪，应当负刑事责任。 　　 <br />
        <br />
        第十九条　又聋又哑的人或者盲人犯罪，可以从轻、减轻或者免除处罚。 　　{" "}
        <br />
        <br />
        第二十条　为了使国家、公共利益、本人或者他人的人身、财产和其他权利免受正在进行的不法侵害，而采取的制止不法侵害的行为，对不法侵害人造成损害的，属于正当防卫，不负刑事责任。
        　　正当防卫明显超过必要限度造成重大损害的，应当负刑事责任，但是应当减轻或者免除处罚。
        　　对正在进行行凶、杀人、抢劫、强奸、绑架以及其他严重危及人身安全的暴力犯罪，采取防卫行为，造成不法侵害人伤亡的，不属于防卫过当，不负刑事责任。
        　　 <br />
        <br />
        第二十一条　为了使国家、公共利益、本人或者他人的人身、财产和其他权利免受正在发生的危险，不得已采取的紧急避险行为，造成损害的，不负刑事责任。
        　　紧急避险超过必要限度造成不应有的损害的，应当负刑事责任，但是应当减轻或者免除处罚。
        　　
        第一款中关于避免本人危险的规定，不适用于职务上、业务上负有特定责任的人。
        <br />
        <br />
        第二节　犯罪的预备、未遂和中止 　　 <br />
        <br />
        第二十二条　为了犯罪，准备工具、制造条件的，是犯罪预备。
        　　对于预备犯，可以比照既遂犯从轻、减轻处罚或者免除处罚。 　　 <br />
        <br />
        第二十三条　已经着手实行犯罪，由于犯罪分子意志以外的原因而未得逞的，是犯罪未遂。
        　　对于未遂犯，可以比照既遂犯从轻或者减轻处罚。 　　 <br />
        <br />
        第二十四条　在犯罪过程中，自动放弃犯罪或者自动有效地防止犯罪结果发生的，是犯罪中止。
        　　对于中止犯，没有造成损害的，应当免除处罚；造成损害的，应当减轻处罚。
        <br />
        <br />
        第三节　共同犯罪 　　 <br />
        <br />
        第二十五条　共同犯罪是指二人以上共同故意犯罪。
        　　二人以上共同过失犯罪，不以共同犯罪论处；应当负刑事责任的，按照他们所犯的罪分别处罚。
        　　 <br />
        <br />
        第二十六条　组织、领导犯罪集团进行犯罪活动的或者在共同犯罪中起主要作用的，是主犯。
        　　三人以上为共同实施犯罪而组成的较为固定的犯罪组织，是犯罪集团。
        　　对组织、领导犯罪集团的首要分子，按照集团所犯的全部罪行处罚。
        　　对于
        第三款规定以外的主犯，应当按照其所参与的或者组织、指挥的全部犯罪处罚。
        　　 <br />
        <br />
        第二十七条　在共同犯罪中起次要或者辅助作用的，是从犯。
        　　对于从犯，应当从轻、减轻处罚或者免除处罚。 　　 <br />
        <br />
        第二十八条　对于被胁迫参加犯罪的，应当按照他的犯罪情节减轻处罚或者免除处罚。
        　　 <br />
        <br />
        第二十九条　教唆他人犯罪的，应当按照他在共同犯罪中所起的作用处罚。教唆不满十八周岁的人犯罪的，应当从重处罚。
        　　如果被教唆的人没有犯被教唆的罪，对于教唆犯，可以从轻或者减轻处罚。
        <br />
        <br />
        第四节　单位犯罪 　　 <br />
        <br />
        第三十条　公司、企业、事业单位、机关、团体实施的危害社会的行为，法律规定为单位犯罪的，应当负刑事责任。
        　　 <br />
        <br />
        第三十一条　单位犯罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员判处刑罚。本法分则和其他法律另有规定的，依照规定。
        第三章　刑罚 第一节　刑罚的种类 　　 <br />
        <br />
        第三十二条　刑罚分为主刑和附加刑。 　　 <br />
        <br />
        第三十三条　主刑的种类如下: 　　 <br />
        <br />
        （一）管制； 　　 <br />
        <br />
        （二）拘役； 　　 <br />
        <br />
        （三）有期徒刑； 　　 <br />
        <br />
        （四）无期徒刑； 　　 <br />
        <br />
        （五）死刑。 　　 <br />
        <br />
        第三十四条　附加刑的种类如下: 　　 <br />
        <br />
        （一）罚金； 　　 <br />
        <br />
        （二）剥夺政治权利； 　　 <br />
        <br />
        （三）没收财产。 　　附加刑也可以独立适用。 　　 <br />
        <br />
        第三十五条　对于犯罪的外国人，可以独立适用或者附加适用驱逐出境。 　　{" "}
        <br />
        <br />
        第三十六条　由于犯罪行为而使被害人遭受经济损失的，对犯罪分子除依法给予刑事处罚外，并应根据情况判处赔偿经济损失。
        　　承担民事赔偿责任的犯罪分子，同时被判处罚金，其财产不足以全部支付的，或者被判处没收财产的，应当先承担对被害人的民事赔偿责任。
        　　 <br />
        <br />
        第三十七条　对于犯罪情节轻微不需要判处刑罚的，可以免予刑事处罚，但是可以根据案件的不同情况，予以训诫或者责令具结悔过、赔礼道歉、赔偿损失，或者由主管部门予以行政处罚或者行政处分。
        <br />
        <br />
        第二节　管制 　　 <br />
        <br />
        第三十八条　管制的期限，为三个月以上二年以下。
        　　被判处管制的犯罪分子，由公安机关执行。 　　 <br />
        <br />
        第三十九条　被判处管制的犯罪分子，在执行期间，应当遵守下列规定: 　　{" "}
        <br />
        <br />
        （一）遵守法律、行政法规，服从监督； 　　 <br />
        <br />
        （二）未经执行机关批准，不得行使言论、出版、集会、结社、游行、示威自由的权利；
        　　 <br />
        <br />
        （三）按照执行机关规定报告自己的活动情况； 　　 <br />
        <br />
        （四）遵守执行机关关于会客的规定； 　　 <br />
        <br />
        （五）离开所居住的市、县或者迁居，应当报经执行机关批准。
        　　对于被判处管制的犯罪分子，在劳动中应当同工同酬。 　　 <br />
        <br />
        第四十条　被判处管制的犯罪分子，管制期满，执行机关应即向本人和其所在单位或者居住地的群众宣布解除管制。
        　　 <br />
        <br />
        第四十一条　管制的刑期，从判决执行之日起计算；判决执行以前先行羁押的，羁押一日折抵刑期二日。
        <br />
        <br />
        第三节　拘役 　　 <br />
        <br />
        第四十二条　拘役的期限，为一个月以上六个月以下。 　　 <br />
        <br />
        第四十三条　被判处拘役的犯罪分子，由公安机关就近执行。
        　　在执行期间，被判处拘役的犯罪分子每月可以回家一天至两天；参加劳动的，可以酌量发给报酬。
        　　 <br />
        <br />
        第四十四条　拘役的刑期，从判决执行之日起计算；判决执行以前先行羁押的，羁押一日折抵刑期一日。
        <br />
        <br />
        第四节　有期徒刑、无期徒刑 　　 <br />
        <br />
        第四十五条　有期徒刑的期限，除本法 
        第五十条、 
        第六十九条规定外，为六个月以上十五年以下。 　　 <br />
        <br />
        第四十六条　被判处有期徒刑、无期徒刑的犯罪分子，在监狱或者其他执行场所执行；凡有劳动能力的，都应当参加劳动，接受教育和改造。
        　　 <br />
        <br />
        第四十七条　有期徒刑的刑期，从判决执行之日起计算；判决执行以前先行羁押的，羁押一日折抵刑期一日。
        <br />
        <br />
        第五节　死刑 　　 <br />
        <br />
        第四十八条　死刑只适用于罪行极其严重的犯罪分子。对于应当判处死刑的犯罪分子，如果不是必须立即执行的，可以判处死刑同时宣告缓期二年执行。
        　　死刑除依法由最高人民法院判决的以外，都应当报请最高人民法院核准。死刑缓期执行的，可以由高级人民法院判决或者核准。
        　　 <br />
        <br />
        第四十九条　犯罪的时候不满十八周岁的人和审判的时候怀孕的妇女，不适用死刑。
        　　 <br />
        <br />
        第五十条　判处死刑缓期执行的，在死刑缓期执行期间，如果没有故意犯罪，二年期满以后，减为无期徒刑；如果确有重大立功表现，二年期满以后，减为十五年以上二十年以下有期徒刑；如果故意犯罪，查证属实的，由最高人民法院核准，执行死刑。
        　　 <br />
        <br />
        第五十一条　死刑缓期执行的期间，从判决确定之日起计算。死刑缓期执行减为有期徒刑的刑期，从死刑缓期执行期满之日起计算。
        <br />
        <br />
        第六节　罚金 　　 <br />
        <br />
        第五十二条　判处罚金，应当根据犯罪情节决定罚金数额。 　　 <br />
        <br />
        第五十三条　罚金在判决指定的期限内一次或者分期缴纳。期满不缴纳的，强制缴纳。对于不能全部缴纳罚金的，人民法院在任何时候发现被执行人有可以执行的财产，应当随时追缴。如果由于遭遇不能抗拒的灾祸缴纳确实有困难的，可以酌情减少或者免除。
        <br />
        <br />
        第七节　剥夺政治权利 　　 <br />
        <br />
        第五十四条　剥夺政治权利是剥夺下列权利: 　　 <br />
        <br />
        （一）选举权和被选举权； 　　 <br />
        <br />
        （二）言论、出版、集会、结社、游行、示威自由的权利； 　　 <br />
        <br />
        （三）担任国家机关职务的权利； 　　 <br />
        <br />
        （四）担任国有公司、企业、事业单位和人民团体领导职务的权利。 　　 <br />
        <br />
        第五十五条　剥夺政治权利的期限，除本法
        第五十七条规定外，为一年以上五年以下。
        　　判处管制附加剥夺政治权利的，剥夺政治权利的期限与管制的期限相等，同时执行。
        　　 <br />
        <br />
        第五十六条　对于危害国家安全的犯罪分子应当附加剥夺政治权利；对于故意杀人、强奸、放火、爆炸、投毒、抢劫等严重破坏社会秩序的犯罪分子，可以附加剥夺政治权利。
        　　独立适用剥夺政治权利的，依照本法分则的规定。 　　 <br />
        <br />
        第五十七条　对于被判处死刑、无期徒刑的犯罪分子，应当剥夺政治权利终身。
        　　在死刑缓期执行减为有期徒刑或者无期徒刑减为有期徒刑的时候，应当把附加剥夺政治权利的期限改为三年以上十年以下。
        　　 <br />
        <br />
        第五十八条　附加剥夺政治权利的刑期，从徒刑、拘役执行完毕之日或者从假释之日起计算；剥夺政治权利的效力当然施用于主刑执行期间。
        　　被剥夺政治权利的犯罪分子，在执行期间，应当遵守法律、行政法规和国务院公安部门有关监督管理的规定，服从监督；不得行使本法{" "}
        第五十四条规定的各项权利。
        <br />
        <br />
        第八节　没收财产 　　 <br />
        <br />
        第五十九条　没收财产是没收犯罪分子个人所有财产的一部或者全部。没收全部财产的，应当对犯罪分子个人及其扶养的家属保留必需的生活费用。
        　　在判处没收财产的时候，不得没收属于犯罪分子家属所有或者应有的财产。
        　　 <br />
        <br />
        第六十条　没收财产以前犯罪分子所负的正当债务，需要以没收的财产偿还的，经债权人请求，应当偿还。
        <br />
        <br />
        第四章　刑罚的具体运用 <br />
        <br />
        第一节　量刑 　　 <br />
        <br />
        第六十一条　对于犯罪分子决定刑罚的时候，应当根据犯罪的事实、犯罪的性质、情节和对于社会的危害程度，依照本法的有关规定判处。
        　　 <br />
        <br />
        第六十二条　犯罪分子具有本法规定的从重处罚、从轻处罚情节的，应当在法定刑的限度以内判处刑罚。
        　　 <br />
        <br />
        第六十三条　犯罪分子具有本法规定的减轻处罚情节的，应当在法定刑以下判处刑罚。
        　　犯罪分子虽然不具有本法规定的减轻处罚情节，但是根据案件的特殊情况，经最高人民法院核准，也可以在法定刑以下判处刑罚。
        　　 <br />
        <br />
        第六十四条　犯罪分子违法所得的一切财物，应当予以追缴或者责令退赔；对被害人的合法财产，应当及时返还；违禁品和供犯罪所用的本人财物，应当予以没收。没收的财物和罚金，一律上缴国库，不得挪用和自行处理。
        <br />
        <br />
        第二节　累犯 　　 <br />
        <br />
        第六十五条　被判处有期徒刑以上刑罚的犯罪分子，刑罚执行完毕或者赦免以后，在五年以内再犯应当判处有期徒刑以上刑罚之罪的，是累犯，应当从重处罚，但是过失犯罪除外。
        　　前款规定的期限，对于被假释的犯罪分子，从假释期满之日起计算。 　　{" "}
        <br />
        <br />
        第六十六条　危害国家安全的犯罪分子在刑罚执行完毕或者赦免以后，在任何时候再犯危害国家安全罪的，都以累犯论处。
        <br />
        <br />
        第三节　自首和立功 　　 <br />
        <br />
        第六十七条　犯罪以后自动投案，如实供述自己的罪行的，是自首。对于自首的犯罪分子，可以从轻或者减轻处罚。其中，犯罪较轻的，可以免除处罚。
        　　被采取强制措施的犯罪嫌疑人、被告人和正在服刑的罪犯，如实供述司法机关还未掌握的本人其他罪行的，以自首论。
        　　 <br />
        <br />
        第六十八条　犯罪分子有揭发他人犯罪行为，查证属实的，或者提供重要线索，从而得以侦破其他案件等立功表现的，可以从轻或者减轻处罚；有重大立功表现的，可以减轻或者免除处罚。
        　　犯罪后自首又有重大立功表现的，应当减轻或者免除处罚。
        <br />
        <br />
        第四节　数罪并罚 　　 <br />
        <br />
        第六十九条　判决宣告以前一人犯数罪的，除判处死刑和无期徒刑的以外，应当在总和刑期以下、数刑中最高刑期以上，酌情决定执行的刑期，但是管制最高不能超过三年，拘役最高不能超过一年，有期徒刑最高不能超过二十年。
        　　如果数罪中有判处附加刑的，附加刑仍须执行。 　　 <br />
        <br />
        第七十条　判决宣告以后，刑罚执行完毕以前，发现被判刑的犯罪分子在判决宣告以前还有其他罪没有判决的，应当对新发现的罪作出判决，把前后两个判决所判处的刑罚，依照本法{" "}
        <br />
        <br />
        第六十九条的规定，决定执行的刑罚。已经执行的刑期，应当计算在新判决决定的刑期以内。
        　　 <br />
        <br />
        第七十一条　判决宣告以后，刑罚执行完毕以前，被判刑的犯罪分子又犯罪的，应当对新犯的罪作出判决，把前罪没有执行的刑罚和后罪所判处的刑罚，依照本法{" "}
        <br />
        <br />
        第六十九条的规定，决定执行的刑罚。
        第五节　缓刑 　　
        第七十二条　对于被判处拘役、三年以下有期徒刑的犯罪分子，根据犯罪分子的犯罪情节和悔罪表现，适用缓刑确实不致再危害社会的，可以宣告缓刑。
        　　被宣告缓刑的犯罪分子，如果被判处附加刑，附加刑仍须执行。 　　 <br />
        <br />
        第七十三条　拘役的缓刑考验期限为原判刑期以上一年以下，但是不能少于二个月。
        　　有期徒刑的缓刑考验期限为原判刑期以上五年以下，但是不能少于一年。
        　　缓刑考验期限，从判决确定之日起计算。 　　 <br />
        <br />
        第七十四条　对于累犯，不适用缓刑。 　　 <br />
        <br />
        第七十五条　被宣告缓刑的犯罪分子，应当遵守下列规定: 　　 <br />
        <br />
        （一）遵守法律、行政法规，服从监督； 　　 <br />
        <br />
        （二）按照考察机关的规定报告自己的活动情况； 　　 <br />
        <br />
        （三）遵守考察机关关于会客的规定； 　　 <br />
        <br />
        （四）离开所居住的市、县或者迁居，应当报经考察机关批准。 　　 <br />
        <br />
        第七十六条　被宣告缓刑的犯罪分子，在缓刑考验期限内，由公安机关考察，所在单位或者基层组织予以配合，如果没有本法{" "}
        <br />
        <br />
        第七十七条规定的情形，缓刑考验期满，原判的刑罚就不再执行，并公开予以宣告。
        　　 <br />
        <br />
        第七十七条　被宣告缓刑的犯罪分子，在缓刑考验期限内犯新罪或者发现判决宣告以前还有其他罪没有判决的，应当撤销缓刑，对新犯的罪或者新发现的罪作出判决，把前罪和后罪所判处的刑罚，依照本法{" "}
        <br />
        <br />
        第六十九条的规定，决定执行的刑罚。
        　　被宣告缓刑的犯罪分子，在缓刑考验期限内，违反法律、行政法规或者国务院公安部门有关缓刑的监督管理规定，情节严重的，应当撤销缓刑，执行原判刑罚。
        <br />
        <br />
        第六节　减刑 　　 <br />
        <br />
        第七十八条　被判处管制、拘役、有期徒刑、无期徒刑的犯罪分子，在执行期间，如果认真遵守监规，接受教育改造，确有悔改表现的，或者有立功表现的，可以减刑；有下列重大立功表现之一的，应当减刑:
        　　 <br />
        <br />
        （一）阻止他人重大犯罪活动的； 　　 <br />
        <br />
        （二）检举监狱内外重大犯罪活动，经查证属实的； 　　 <br />
        <br />
        （三）有发明创造或者重大技术革新的； 　　 <br />
        <br />
        （四）在日常生产、生活中舍己救人的； 　　 <br />
        <br />
        （五）在抗御自然灾害或者排除重大事故中，有突出表现的； 　　 <br />
        <br />
        （六）对国家和社会有其他重大贡献的。
        　　减刑以后实际执行的刑期，判处管制、拘役、有期徒刑的，不能少于原判刑期的二分之一；判处无期徒刑的，不能少于十年。
        　　 <br />
        <br />
        第七十九条　对于犯罪分子的减刑，由执行机关向中级以上人民法院提出减刑建议书。人民法院应当组成合议庭进行审理，对确有悔改或者立功事实的，裁定予以减刑。非经法定程序不得减刑。
        　　 <br />
        <br />
        第八十条　无期徒刑减为有期徒刑的刑期，从裁定减刑之日起计算。
        <br />
        <br />
        第七节　假释 　　 <br />
        <br />
        第八十一条　被判处有期徒刑的犯罪分子，执行原判刑期二分之一以上，被判处无期徒刑的犯罪分子，实际执行十年以上，如果认真遵守监规，接受教育改造，确有悔改表现，假释后不致再危害社会的，可以假释。如果有特殊情况，经最高人民法院核准，可以不受上述执行刑期的限制。
        　　对累犯以及因杀人、爆炸、抢劫、强奸、绑架等暴力性犯罪被判处十年以上有期徒刑、无期徒刑的犯罪分子，不得假释。
        　　 <br />
        <br />
        第八十二条　对于犯罪分子的假释，依照本法 
        第七十九条规定的程序进行。非经法定程序不得假释。 　　 <br />
        <br />
        第八十三条　有期徒刑的假释考验期限，为没有执行完毕的刑期；无期徒刑的假释考验期限为十年。
        　　假释考验期限，从假释之日起计算。 　　 <br />
        <br />
        第八十四条　被宣告假释的犯罪分子，应当遵守下列规定: 　　 <br />
        <br />
        （一）遵守法律、行政法规，服从监督； 　　 <br />
        <br />
        （二）按照监督机关的规定报告自己的活动情况； 　　 <br />
        <br />
        （三）遵守监督机关关于会客的规定； 　　 <br />
        <br />
        （四）离开所居住的市、县或者迁居，应当报经监督机关批准。 　　 <br />
        <br />
        第八十五条　被假释的犯罪分子，在假释考验期限内，由公安机关予以监督，如果没有本法{" "}
        <br />
        <br />
        第八十六条规定的情形，假释考验期满，就认为原判刑罚已经执行完毕，并公开予以宣告。
        　　 <br />
        <br />
        第八十六条　被假释的犯罪分子，在假释考验期限内犯新罪，应当撤销假释，依照本法{" "}
       
        第七十一条的规定实行数罪并罚。
        　　在假释考验期限内，发现被假释的犯罪分子在判决宣告以前还有其他罪没有判决的，应当撤销假释，依照本法{" "}
        第七十条的规定实行数罪并罚。
        　　被假释的犯罪分子，在假释考验期限内，有违反法律、行政法规或者国务院公安部门有关假释的监督管理规定的行为，尚未构成新的犯罪的，应当依照法定程序撤销假释，收监执行未执行完毕的刑罚。
        <br />
        <br />
        第八节　时效 　　 <br />
        <br />
        第八十七条　犯罪经过下列期限不再追诉: 　　 <br />
        <br />
        （一）法定最高刑为不满五年有期徒刑的，经过五年； 　　 <br />
        <br />
        （二）法定最高刑为五年以上不满十年有期徒刑的，经过十年； 　　 <br />
        <br />
        （三）法定最高刑为十年以上有期徒刑的，经过十五年； 　　 <br />
        <br />
        （四）法定最高刑为无期徒刑、死刑的，经过二十年。如果二十年以后认为必须追诉的，须报请最高人民检察院核准。
        　　 <br />
        <br />
        第八十八条　在人民检察院、公安机关、国家安全机关立案侦查或者在人民法院受理案件以后，逃避侦查或者审判的，不受追诉期限的限制。
        　　被害人在追诉期限内提出控告，人民法院、人民检察院、公安机关应当立案而不予立案的，不受追诉期限的限制。
        　　 <br />
        <br />
        第八十九条　追诉期限从犯罪之日起计算；犯罪行为有连续或者继续状态的，从犯罪行为终了之日起计算。在追诉期限以内又犯罪的，前罪追诉的期限从犯后罪之日起计算。
        <br />
        <br />
        第五章　其他规定 　　 <br />
        <br />
        第九十条　民族自治地方不能全部适用本法规定的，可以由自治区或者省的人民代表大会根据当地民族的政治、经济、文化的特点和本法规定的基本原则，制定变通或者补充的规定，报请全国人民代表大会常务委员会批准施行。
        　　 <br />
        <br />
        第九十一条　本法所称公共财产，是指下列财产: 　　 <br />
        <br />
        （一）国有财产； 　　 <br />
        <br />
        （二）劳动群众集体所有的财产； 　　 <br />
        <br />
        （三）用于扶贫和其他公益事业的社会捐助或者专项基金的财产。
        　　在国家机关、国有公司、企业、集体企业和人民团体管理、使用或者运输中的私人财产，以公共财产论。
        　　 <br />
        <br />
        第九十二条　本法所称公民私人所有的财产，是指下列财产: 　　 <br />
        <br />
        （一）公民的合法收入、储蓄、房屋和其他生活资料； 　　 <br />
        <br />
        （二）依法归个人、家庭所有的生产资料； 　　 <br />
        <br />
        （三）个体户和私营企业的合法财产； 　　 <br />
        <br />
        （四）依法归个人所有的股份、股票、债券和其他财产。 　　 <br />
        <br />
        第九十三条　本法所称国家工作人员，是指国家机关中从事公务的人员。
        　　国有公司、企业、事业单位、人民团体中从事公务的人员和国家机关、国有公司、企业、事业单位委派到非国有公司、企业、事业单位、社会团体从事公务的人员，以及其他依照法律从事公务的人员，以国家工作人员论。
        　　 <br />
        <br />
        第九十四条　本法所称司法工作人员，是指有侦查、检察、审判、监管职责的工作人员。
        　　 <br />
        <br />
        第九十五条　本法所称重伤，是指有下列情形之一的伤害: 　　 <br />
        <br />
        （一）使人肢体残废或者毁人容貌的； 　　 <br />
        <br />
        （二）使人丧失听觉、视觉或者其他器官机能的； 　　 <br />
        <br />
        （三）其他对于人身健康有重大伤害的。 　　 <br />
        <br />
        第九十六条　本法所称违反国家规定，是指违反全国人民代表大会及其常务委员会制定的法律和决定，国务院制定的行政法规、规定的行政措施、发布的决定和命令。
        　　 <br />
        <br />
        第九十七条　本法所称首要分子，是指在犯罪集团或者聚众犯罪中起组织、策划、指挥作用的犯罪分子。
        　　 <br />
        <br />
        第九十八条　本法所称告诉才处理，是指被害人告诉才处理。如果被害人因受强制、威吓无法告诉的，人民检察院和被害人的近亲属也可以告诉。
        　　 <br />
        <br />
        第九十九条　本法所称以上、以下、以内，包括本数。 　　 <br />
        <br />
        第一百条　依法受过刑事处罚的人，在入伍、就业的时候，应当如实向有关单位报告自己曾受过刑事处罚，不得隐瞒。
        　　 <br />
        <br />
        第一百零一条　本法总则适用于其他有刑罚规定的法律，但是其他法律有特别规定的除外。
        <br />
        <br />
        第二编　分则 <br />
        <br />
        第一章　危害国家安全罪 　　 <br />
        <br />
        第一百零二条　勾结外国，危害中华人民共和国的主权、领土完整和安全的，处无期徒刑或者十年以上有期徒刑。
        　　与境外机构、组织、个人相勾结，犯前款罪的，依照前款的规定处罚。 　　{" "}
        <br />
        <br />
        第一百零三条　组织、策划、实施分裂国家、破坏国家统一的，对首要分子或者罪行重大的，处无期徒刑或者十年以上有期徒刑；对积极参加的，处三年以上十年以下有期徒刑；对其他参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　煽动分裂国家、破坏国家统一的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利；首要分子或者罪行重大的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第一百零四条　组织、策划、实施武装叛乱或者武装暴乱的，对首要分子或者罪行重大的，处无期徒刑或者十年以上有期徒刑；对积极参加的，处三年以上十年以下有期徒刑；对其他参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　策动、胁迫、勾引、收买国家机关工作人员、武装部队人员、人民警察、民兵进行武装叛乱或者武装暴乱的，依照前款的规定从重处罚。
        　　 <br />
        <br />
        第一百零五条　组织、策划、实施颠覆国家政权、推翻社会主义制度的，对首要分子或者罪行重大的，处无期徒刑或者十年以上有期徒刑；对积极参加的，处三年以上十年以下有期徒刑；对其他参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　以造谣、诽谤或者其他方式煽动颠覆国家政权、推翻社会主义制度的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利；首要分子或者罪行重大的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第一百零六条　与境外机构、组织、个人相勾结，实施本章 
        第一百零三条、 
        第一百零四条、 
        第一百零五条规定之罪的，依照各该条的规定从重处罚。 　　 <br />
        <br />
        第一百零七条　境内外机构、组织或者个人资助境内组织或者个人实施本章{" "}
       
        第一百零二条、 
        第一百零三条、
        第一百零四条、
        第一百零五条规定之罪的，对直接责任人员，处五年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第一百零八条　投敌叛变的，处三年以上十年以下有期徒刑；情节严重或者带领武装部队人员、人民警察、民兵投敌叛变的，处十年以上有期徒刑或者无期徒刑。
        　　 <br />
        <br />
        第一百零九条　国家机关工作人员在履行公务期间，擅离岗位，叛逃境外或者在境外叛逃，危害中华人民共和国国家安全的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处五年以上十年以下有期徒刑。
        　　掌握国家秘密的国家工作人员犯前款罪的，依照前款的规定从重处罚。 　　{" "}
        <br />
        <br />
        第一百一十条　有下列间谍行为之一，危害国家安全的，处十年以上有期徒刑或者无期徒刑；情节较轻的，处三年以上十年以下有期徒刑：
        　　 <br />
        <br />
        （一）参加间谍组织或者接受间谍组织及其代理人的任务的； 　　 <br />
        <br />
        （二）为敌人指示轰击目标的。 　　 <br />
        <br />
        第一百一十一条　为境外的机构、组织、人员窃取、刺探、收买、非法提供国家秘密或者情报的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑或者无期徒刑；情节较轻的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第一百一十二条　战时供给敌人武器装备、军用物资资敌的，处十年以上有期徒刑或者无期徒刑；情节较轻的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第一百一十三条　本章上述危害国家安全罪行中，除 <br />
        <br />
        第一百零三条 <br />
        <br />
        第二款、 <br />
        <br />
        第一百零五条、 <br />
        <br />
        第一百零七条、 <br />
        <br />
        第一百零九条外，对国家和人民危害特别严重、情节特别恶劣的，可以判处死刑。
        　　犯本章之罪的，可以并处没收财产。 <br />
        <br />
        第二章　危害公共安全罪 　　 <br />
        <br />
        第一百一十四条　放火、决水、爆炸、投毒或者以其他危险方法破坏工厂、矿场、油田、港口、河流、水源、仓库、住宅、森林、农场、谷场、牧场、重要管道、公共建筑物或者其他公私财产，危害公共安全，尚未造成严重后果的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第一百一十五条　放火、决水、爆炸、投毒或者以其他危险方法致人重伤、死亡或者使公私财产遭受重大损失的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　过失犯前款罪的，处三年以上七年以下有期徒刑；情节较轻的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百一十六条　破坏火车、汽车、电车、船只、航空器，足以使火车、汽车、电车、船只、航空器发生倾覆、毁坏危险，尚未造成严重后果的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第一百一十七条　破坏轨道、桥梁、隧道、公路、机场、航道、灯塔、标志或者进行其他破坏活动，足以使火车、汽车、电车、船只、航空器发生倾覆、毁坏危险，尚未造成严重后果的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第一百一十八条　破坏电力、燃气或者其他易燃易爆设备，危害公共安全，尚未造成严重后果的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第一百一十九条　破坏交通工具、交通设施、电力设备、燃气设备、易燃易爆设备，造成严重后果的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　过失犯前款罪的，处三年以上七年以下有期徒刑；情节较轻的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百二十条　组织、领导和积极参加恐怖活动组织的，处三年以上十年以下有期徒刑；其他参加的，处三年以下有期徒刑、拘役或者管制。
        　　犯前款罪并实施杀人、爆炸、绑架等犯罪的，依照数罪并罚的规定处罚。
        　　 <br />
        <br />
        第一百二十一条　以暴力、胁迫或者其他方法劫持航空器的，处十年以上有期徒刑或者无期徒刑；致人重伤、死亡或者使航空器遭受严重破坏的，处死刑。
        　　 <br />
        <br />
        第一百二十二条　以暴力、胁迫或者其他方法劫持船只、汽车的，处五年以上十年以下有期徒刑；造成严重后果的，处十年以上有期徒刑或者无期徒刑。
        　　 <br />
        <br />
        第一百二十三条　对飞行中的航空器上的人员使用暴力，危及飞行安全，尚未造成严重后果的，处五年以下有期徒刑或者拘役；造成严重后果的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第一百二十四条　破坏广播电视设施、公用电信设施，危害公共安全的，处三年以上七年以下有期徒刑；造成严重后果的，处七年以上有期徒刑。
        　　过失犯前款罪的，处三年以上七年以下有期徒刑；情节较轻的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百二十五条　非法制造、买卖、运输、邮寄、储存枪支、弹药、爆炸物的，处三年以上十年以下有期徒刑；情节严重的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　非法买卖、运输核材料的，依照前款的规定处罚。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第一百二十六条　依法被指定、确定的枪支制造企业、销售企业，违反枪支管理规定，有下列行为之一的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑或者无期徒刑：
        　　 <br />
        <br />
        （一）以非法销售为目的，超过限额或者不按照规定的品种制造、配售枪支的；
        　　 <br />
        <br />
        （二）以非法销售为目的，制造无号、重号、假号的枪支的； 　　 <br />
        <br />
        （三）非法销售枪支或者在境内销售为出口制造的枪支的。 　　 <br />
        <br />
        第一百二十七条　盗窃、抢夺枪支、弹药、爆炸物的，处三年以上十年以下有期徒刑；情节严重的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　抢劫枪支、弹药、爆炸物或者盗窃、抢夺国家机关、军警人员、民兵的枪支、弹药、爆炸物的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第一百二十八条　违反枪支管理规定，非法持有、私藏枪支、弹药的，处三年以下有期徒刑、拘役或者管制；情节严重的，处三年以上七年以下有期徒刑。
        　　依法配备公务用枪的人员，非法出租、出借枪支的，依照前款的规定处罚。
        　　依法配置枪支的人员，非法出租、出借枪支，造成严重后果的，依照 <br />
        <br />
        第一款的规定处罚。 　　单位犯 <br />
        <br />
        第二款、 <br />
        <br />
        第三款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第一百二十九条　依法配备公务用枪的人员，丢失枪支不及时报告，造成严重后果的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百三十条　非法携带枪支、弹药、管制刀具或者爆炸性、易燃性、放射性、毒害性、腐蚀性物品，进入公共场所或者公共交通工具，危及公共安全，情节严重的，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第一百三十一条　航空人员违反规章制度，致使发生重大飞行事故，造成严重后果的，处三年以下有期徒刑或者拘役；造成飞机坠毁或者人员死亡的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十二条　铁路职工违反规章制度，致使发生铁路运营安全事故，造成严重后果的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十三条　违反交通运输管理法规，因而发生重大事故，致人重伤、死亡或者使公私财产遭受重大损失的，处三年以下有期徒刑或者拘役；交通运输肇事后逃逸或者有其他特别恶劣情节的，处三年以上七年以下有期徒刑；因逃逸致人死亡的，处七年以上有期徒刑。
        　　 <br />
        <br />
        第一百三十四条　工厂、矿山、林场、建筑企业或者其他企业、事业单位的职工，由于不服管理、违反规章制度，或者强令工人违章冒险作业，因而发生重大伤亡事故或者造成其他严重后果的，处三年以下有期徒刑或者拘役；情节特别恶劣的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十五条　工厂、矿山、林场、建筑企业或者其他企业、事业单位的劳动安全设施不符合国家规定，经有关部门或者单位职工提出后，对事故隐患仍不采取措施，因而发生重大伤亡事故或者造成其他严重后果的，对直接责任人员，处三年以下有期徒刑或者拘役；情节特别恶劣的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十六条　违反爆炸性、易燃性、放射性、毒害性、腐蚀性物品的管理规定，在生产、储存、运输、使用中发生重大事故，造成严重后果的，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十七条　建设单位、设计单位、施工单位、工程监理单位违反国家规定，降低工程质量标准，造成重大安全事故的，对直接责任人员，处五年以下有期徒刑或者拘役，并处罚金；后果特别严重的，处五年以上十年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第一百三十八条　明知校舍或者教育教学设施有危险，而不采取措施或者不及时报告，致使发生重大伤亡事故的，对直接责任人员，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百三十九条　违反消防管理法规，经消防监督机构通知采取改正措施而拒绝执行，造成严重后果的，对直接责任人员，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑。
        <br />
        <br />
        第三章　破坏社会主义市场经济秩序罪 <br />
        <br />
        第一节　生产、销售伪劣商品罪 　　 <br />
        <br />
        第一百四十条　生产者、销售者在产品中掺杂、掺假，以假充真，以次充好或者以不合格产品冒充合格产品，销售金额五万元以上不满二十万元的，处二年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金；销售金额二十万元以上不满五十万元的，处二年以上七年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；销售金额五十万元以上不满二百万元的，处七年以上有期徒刑，并处销售金额百分之五十以上二倍以下罚金；销售金额二百万元以上的，处十五年有期徒刑或者无期徒刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百四十一条　生产、销售假药，足以严重危害人体健康的，处三年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金；对人体健康造成严重危害的，处三年以上十年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；致人死亡或者对人体健康造成特别严重危害的，处十年以上有期徒刑、无期徒刑或者死刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　本条所称假药，是指依照《中华人民共和国药品管理法》的规定属于假药和按假药处理的药品、非药品。
        　　 <br />
        <br />
        第一百四十二条　生产、销售劣药，对人体健康造成严重危害的，处三年以上十年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；后果特别严重的，处十年以上有期徒刑或者无期徒刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　本条所称劣药，是指依照《中华人民共和国药品管理法》的规定属于劣药的药品。
        　　 <br />
        <br />
        第一百四十三条　生产、销售不符合卫生标准的食品，足以造成严重食物中毒事故或者其他严重食源性疾患的，处三年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金；对人体健康造成严重危害的，处三年以上七年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；后果特别严重的，处七年以上有期徒刑或者无期徒刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百四十四条　在生产、销售的食品中掺入有毒、有害的非食品原料的，或者销售明知掺有有毒、有害的非食品原料的食品的，处五年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金；造成严重食物中毒事故或者其他严重食源性疾患，对人体健康造成严重危害的，处五年以上十年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；致人死亡或者对人体健康造成特别严重危害的，依照本法{" "}
        <br />
        <br />
        第一百四十一条的规定处罚。 　　 <br />
        <br />
        第一百四十五条　生产不符合保障人体健康的国家标准、行业标准的医疗器械、医用卫生材料，或者销售明知是不符合保障人体健康的国家标准、行业标准的医疗器械、医用卫生材料，对人体健康造成严重危害的，处五年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；后果特别严重的，处五年以上十年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金，其中情节特别恶劣的，处十年以上有期徒刑或者无期徒刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百四十六条　生产不符合保障人身、财产安全的国家标准、行业标准的电器、压力容器、易燃易爆产品或者其他不符合保障人身、财产安全的国家标准、行业标准的产品，或者销售明知是以上不符合保障人身、财产安全的国家标准、行业标准的产品，造成严重后果的，处五年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；后果特别严重的，处五年以上有期徒刑，并处销售金额百分之五十以上二倍以下罚金。
        　　 <br />
        <br />
        第一百四十七条　生产假农药、假兽药、假化肥，销售明知是假的或者失去使用效能的农药、兽药、化肥、种子，或者生产者、销售者以不合格的农药、兽药、化肥、种子冒充合格的农药、兽药、化肥、种子，使生产遭受较大损失的，处三年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金；使生产遭受重大损失的，处三年以上七年以下有期徒刑，并处销售金额百分之五十以上二倍以下罚金；使生产遭受特别重大损失的，处七年以上有期徒刑或者无期徒刑，并处销售金额百分之五十以上二倍以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百四十八条　生产不符合卫生标准的化妆品，或者销售明知是不符合卫生标准的化妆品，造成严重后果的，处三年以下有期徒刑或者拘役，并处或者单处销售金额百分之五十以上二倍以下罚金。
        　　 <br />
        <br />
        第一百四十九条　生产、销售本节 <br />
        <br />
        第一百四十一条至 <br />
        <br />
        第一百四十八条所列产品，不构成各该条规定的犯罪，但是销售金额在五万元以上的，依照本节{" "}
        <br />
        <br />
        第一百四十条的规定定罪处罚。 　　生产、销售本节 <br />
        <br />
        第一百四十一条至 <br />
        <br />
        第一百四十八条所列产品，构成各该条规定的犯罪，同时又构成本节 <br />
        <br />
        第一百四十条规定之罪的，依照处罚较重的规定定罪处罚。 　　 <br />
        <br />
        第一百五十条　单位犯本节 <br />
        <br />
        第一百四十条至 <br />
        <br />
        第一百四十八条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照各该条的规定处罚。
        <br />
        <br />
        第二节　走私罪 　　 <br />
        <br />
        第一百五十一条　走私武器、弹药、核材料或者伪造的货币的，处七年以上有期徒刑，并处罚金或者没收财产；情节较轻的，处三年以上七年以下有期徒刑，并处罚金。
        　　走私国家禁止出口的文物、黄金、白银和其他贵重金属或者国家禁止进出口的珍贵动物及其制品的，处五年以上有期徒刑，并处罚金；情节较轻的，处五年以下有期徒刑，并处罚金。
        　　走私国家禁止进出口的珍稀植物及其制品的，处五年以下有期徒刑，并处或者单处罚金；情节严重的，处五年以上有期徒刑，并处罚金。
        　　犯 <br />
        <br />
        第一款、 <br />
        <br />
        第二款罪，情节特别严重的，处无期徒刑或者死刑，并处没收财产。
        　　单位犯本条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照本条各款的规定处罚。
        　　 <br />
        <br />
        第一百五十二条　以牟利或者传播为目的，走私淫秽的影片、录像带、录音带、图片、书刊或者其他淫秽物品的，处三年以上十年以下有期徒刑，并处罚金；情节严重的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产；情节较轻的，处三年以下有期徒刑、拘役或者管制，并处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百五十三条　走私本法 <br />
        <br />
        第一百五十一条、 <br />
        <br />
        第一百五十二条、 <br />
        <br />
        第三百四十七条规定以外的货物、物品的，根据情节轻重，分别依照下列规定处罚：
        　　 <br />
        <br />
        （一）走私货物、物品偷逃应缴税额在五十万元以上的，处十年以上有期徒刑或者无期徒刑，并处偷逃应缴税额一倍以上五倍以下罚金或者没收财产；情节特别严重的，依照本法{" "}
        <br />
        <br />
        第一百五十一条 <br />
        <br />
        第四款的规定处罚。 　　 <br />
        <br />
        （二）走私货物、物品偷逃应缴税额在十五万元以上不满五十万元的，处三年以上十年以下有期徒刑，并处偷逃应缴税额一倍以上五倍以下罚金；情节特别严重的，处十年以上有期徒刑或者无期徒刑，并处偷逃应缴税额一倍以上五倍以下罚金或者没收财产。
        　　 <br />
        <br />
        （三）走私货物、物品偷逃应缴税额在五万元以上不满十五万元的，处三年以下有期徒刑或者拘役，并处偷逃应缴税额一倍以上五倍以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役；情节严重的，处三年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑。
        　　对多次走私未经处理的，按照累计走私货物、物品的偷逃应缴税额处罚。
        　　 <br />
        <br />
        第一百五十四条　下列走私行为，根据本节规定构成犯罪的，依照本法 <br />
        <br />
        第一百五十三条的规定定罪处罚： 　　 <br />
        <br />
        （一）未经海关许可并且未补缴应缴税额，擅自将批准进口的来料加工、来件装配、补偿贸易的原材料、零件、制成品、设备等保税货物，在境内销售牟利的；
        　　 <br />
        <br />
        （二）未经海关许可并且未补缴应缴税额，擅自将特定减税、免税进口的货物、物品，在境内销售牟利的。
        　　 <br />
        <br />
        第一百五十五条　下列行为，以走私罪论处，依照本节的有关规定处罚： 　　{" "}
        <br />
        <br />
        （一）直接向走私人非法收购国家禁止进口物品的，或者直接向走私人非法收购走私进口的其他货物、物品，数额较大的；
        　　 <br />
        <br />
        （二）在内海、领海运输、收购、贩卖国家禁止进出口物品的，或者运输、收购、贩卖国家限制进出口货物、物品，数额较大，没有合法证明的；
        　　 <br />
        <br />
        （三）逃避海关监管将境外固体废物运输进境的。 　　 <br />
        <br />
        第一百五十六条　与走私罪犯通谋，为其提供贷款、资金、帐号、发票、证明，或者为其提供运输、保管、邮寄或者其他方便的，以走私罪的共犯论处。
        　　 <br />
        <br />
        第一百五十七条　武装掩护走私的，依照本法 <br />
        <br />
        第一百五十一条 <br />
        <br />
        第一款、 <br />
        <br />
        第四款的规定从重处罚。 　　以暴力、威胁方法抗拒缉私的，以走私罪和本法{" "}
        <br />
        <br />
        第二百七十七条规定的阻碍国家机关工作人员依法执行职务罪，依照数罪并罚的规定处罚。
        <br />
        <br />
        第三节　妨害对公司、企业的管理秩序罪 　　 <br />
        <br />
        第一百五十八条　申请公司登记使用虚假证明文件或者采取其他欺诈手段虚报注册资本，欺骗公司登记主管部门，取得公司登记，虚报注册资本数额巨大、后果严重或者有其他严重情节的，处三年以下有期徒刑或者拘役，并处或者单处虚报注册资本金额百分之一以上百分之五以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百五十九条　公司发起人、股东违反公司法的规定未交付货币、实物或者未转移财产权，虚假出资，或者在公司成立后又抽逃其出资，数额巨大、后果严重或者有其他严重情节的，处五年以下有期徒刑或者拘役，并处或者单处虚假出资金额或者抽逃出资金额百分之二以上百分之十以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百六十条　在招股说明书、认股书、公司、企业债券募集办法中隐瞒重要事实或者编造重大虚假内容，发行股票或者公司、企业债券，数额巨大、后果严重或者有其他严重情节的，处五年以下有期徒刑或者拘役，并处或者单处非法募集资金金额百分之一以上百分之五以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百六十一条　公司向股东和社会公众提供虚假的或者隐瞒重要事实的财务会计报告，严重损害股东或者其他人利益的，对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金。
        　　 <br />
        <br />
        第一百六十二条　公司、企业进行清算时，隐匿财产，对资产负债表或者财产清单作虚伪记载或者在未清偿债务前分配公司、企业财产，严重损害债权人或者其他人利益的，对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金。
        　　 <br />
        <br />
        第一百六十三条　公司、企业的工作人员利用职务上的便利，索取他人财物或者非法收受他人财物，为他人谋取利益，数额较大的，处五年以下有期徒刑或者拘役；数额巨大的，处五年以上有期徒刑，可以并处没收财产。
        　　公司、企业的工作人员在经济往来中，违反国家规定，收受各种名义的回扣、手续费，归个人所有的，依照前款的规定处罚。
        　　国有公司、企业中从事公务的人员和国有公司、企业委派到非国有公司、企业从事公务的人员有前两款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十五条、 <br />
        <br />
        第三百八十六条的规定定罪处罚。 　　 <br />
        <br />
        第一百六十四条　为谋取不正当利益，给予公司、企业的工作人员以财物，数额较大的，处三年以下有期徒刑或者拘役；数额巨大的，处三年以上十年以下有期徒刑，并处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　行贿人在被追诉前主动交待行贿行为的，可以减轻处罚或者免除处罚。 　　{" "}
        <br />
        <br />
        第一百六十五条　国有公司、企业的董事、经理利用职务便利，自己经营或者为他人经营与其所任职公司、企业同类的营业，获取非法利益，数额巨大的，处三年以下有期徒刑或者拘役，并处或者单处罚金；数额特别巨大的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第一百六十六条　国有公司、企业、事业单位的工作人员，利用职务便利，有下列情形之一，使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役，并处或者单处罚金；致使国家利益遭受特别重大损失的，处三年以上七年以下有期徒刑，并处罚金：
        　　 <br />
        <br />
        （一）将本单位的盈利业务交由自己的亲友进行经营的； 　　 <br />
        <br />
        （二）以明显高于市场的价格向自己的亲友经营管理的单位采购商品或者以明显低于市场的价格向自己的亲友经营管理的单位销售商品的；
        　　 <br />
        <br />
        （三）向自己的亲友经营管理的单位采购不合格商品的。 　　 <br />
        <br />
        第一百六十七条　国有公司、企业、事业单位直接负责的主管人员，在签订、履行合同过程中，因严重不负责任被诈骗，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役；致使国家利益遭受特别重大损失的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第一百六十八条　国有公司、企业直接负责的主管人员，徇私舞弊，造成国有公司、企业破产或者严重亏损，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百六十九条　国有公司、企业或者其上级主管部门直接负责的主管人员，徇私舞弊，将国有资产低价折股或者低价出售，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役；致使国家利益遭受特别重大损失的，处三年以上七年以下有期徒刑。
        <br />
        <br />
        第四节　破坏金融管理秩序罪 　　 <br />
        <br />
        第一百七十条　伪造货币的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；有下列情形之一的，处十年以上有期徒刑、无期徒刑或者死刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）伪造货币集团的首要分子； 　　 <br />
        <br />
        （二）伪造货币数额特别巨大的； 　　 <br />
        <br />
        （三）有其他特别严重情节的。 　　 <br />
        <br />
        第一百七十一条　出售、购买伪造的货币或者明知是伪造的货币而运输，数额较大的，处三年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　银行或者其他金融机构的工作人员购买伪造的货币或者利用职务上的便利，以伪造的货币换取货币的，处三年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处十年以上有期徒刑或者无期徒刑，并处二万元以上二十万元以下罚金或者没收财产；情节较轻的，处三年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金。
        　　伪造货币并出售或者运输伪造的货币的，依照本法 <br />
        <br />
        第一百七十条的规定定罪从重处罚。 　　 <br />
        <br />
        第一百七十二条　明知是伪造的货币而持有、使用，数额较大的，处三年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金；数额巨大的，处三年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金；数额特别巨大的，处十年以上有期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百七十三条　变造货币，数额较大的，处三年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金；数额巨大的，处三年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金。
        　　 <br />
        <br />
        第一百七十四条　未经中国人民银行批准，擅自设立商业银行或者其他金融机构的，处三年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金；情节严重的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金。
        　　伪造、变造、转让商业银行或者其他金融机构经营许可证的，依照前款的规定处罚。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第一百七十五条　以转贷牟利为目的，套取金融机构信贷资金高利转贷他人，违法所得数额较大的，处三年以下有期徒刑或者拘役，并处违法所得一倍以上五倍以下罚金；数额巨大的，处三年以上七年以下有期徒刑，并处违法所得一倍以上五倍以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百七十六条　非法吸收公众存款或者变相吸收公众存款，扰乱金融秩序的，处三年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百七十七条　有下列情形之一，伪造、变造金融票证的，处五年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金；情节严重的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；情节特别严重的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）伪造、变造汇票、本票、支票的； 　　 <br />
        <br />
        （二）伪造、变造委托收款凭证、汇款凭证、银行存单等其他银行结算凭证的；
        　　 <br />
        <br />
        （三）伪造、变造信用证或者附随的单据、文件的； 　　 <br />
        <br />
        （四）伪造信用卡的。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百七十八条　伪造、变造国库券或者国家发行的其他有价证券，数额较大的，处三年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金；数额巨大的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　伪造、变造股票或者公司、企业债券，数额较大的，处三年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金；数额巨大的，处三年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前两款的规定处罚。
        　　 <br />
        <br />
        第一百七十九条　未经国家有关主管部门批准，擅自发行股票或者公司、企业债券，数额巨大、后果严重或者有其他严重情节的，处五年以下有期徒刑或者拘役，并处或者单处非法募集资金金额百分之一以上百分之五以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百八十条　证券交易内幕信息的知情人员或者非法获取证券交易内幕信息的人员，在涉及证券的发行、交易或者其他对证券的价格有重大影响的信息尚未公开前，买入或者卖出该证券，或者泄露该信息，情节严重的，处五年以下有期徒刑或者拘役，并处或者单处违法所得一倍以上五倍以下罚金；情节特别严重的，处五年以上十年以下有期徒刑，并处违法所得一倍以上五倍以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　内幕信息的范围，依照法律、行政法规的规定确定。
        　　知情人员的范围，依照法律、行政法规的规定确定。 　　 <br />
        <br />
        第一百八十一条　编造并且传播影响证券交易的虚假信息，扰乱证券交易市场，造成严重后果的，处五年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金。
        　　证券交易所、证券公司的从业人员，证券业协会或者证券管理部门的工作人员，故意提供虚假信息或者伪造、变造、销毁交易记录，诱骗投资者买卖证券，造成严重后果的，处五年以下有期徒刑或者拘役，并处或者单处一万元以上十万元以下罚金；情节特别恶劣的，处五年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百八十二条　有下列情形之一，操纵证券交易价格，获取不正当利益或者转嫁风险，情节严重的，处五年以下有期徒刑或者拘役，并处或者单处违法所得一倍以上五倍以下罚金：
        　　 <br />
        <br />
        （一）单独或者合谋，集中资金优势、持股优势或者利用信息优势联合或者连续买卖，操纵证券交易价格的；
        　　 <br />
        <br />
        （二）与他人串通，以事先约定的时间、价格和方式相互进行证券交易或者相互买卖并不持有的证券，影响证券交易价格或者证券交易量的；
        　　 <br />
        <br />
        （三）以自己为交易对象，进行不转移证券所有权的自买自卖，影响证券交易价格或者证券交易量的；
        　　 <br />
        <br />
        （四）以其他方法操纵证券交易价格的。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百八十三条　保险公司的工作人员利用职务上的便利，故意编造未曾发生的保险事故进行虚假理赔，骗取保险金归自己所有的，依照本法{" "}
        <br />
        <br />
        第二百七十一条的规定定罪处罚。
        　　国有保险公司工作人员和国有保险公司委派到非国有保险公司从事公务的人员有前款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十二条、 <br />
        <br />
        第三百八十三条的规定定罪处罚。 　　 <br />
        <br />
        第一百八十四条　银行或者其他金融机构的工作人员在金融业务活动中索取他人财物或者非法收受他人财物，为他人谋取利益的，或者违反国家规定，收受各种名义的回扣、手续费，归个人所有的，依照本法{" "}
        <br />
        <br />
        第一百六十三条的规定定罪处罚。
        　　国有金融机构工作人员和国有金融机构委派到非国有金融机构从事公务的人员有前款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十五条、 <br />
        <br />
        第三百八十六条的规定定罪处罚。 　　 <br />
        <br />
        第一百八十五条　银行或者其他金融机构的工作人员利用职务上的便利，挪用本单位或者客户资金的，依照本法{" "}
        <br />
        <br />
        第二百七十二条的规定定罪处罚。
        　　国有金融机构工作人员和国有金融机构委派到非国有金融机构从事公务的人员有前款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十四条的规定定罪处罚。 　　 <br />
        <br />
        第一百八十六条　银行或者其他金融机构的工作人员违反法律、行政法规规定，向关系人发放信用贷款或者发放担保贷款的条件优于其他借款人同类贷款的条件，造成较大损失的，处五年以下有期徒刑或者拘役，并处一万元以上十万元以下罚金；造成重大损失的，处五年以上有期徒刑，并处二万元以上二十万元以下罚金。
        　　银行或者其他金融机构的工作人员违反法律、行政法规规定，向关系人以外的其他人发放贷款，造成重大损失的，处五年以下有期徒刑或者拘役，并处一万元以上十万元以下罚金；造成特别重大损失的，处五年以上有期徒刑，并处二万元以上二十万元以下罚金。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前两款的规定处罚。
        　　关系人的范围，依照《中华人民共和国商业银行法》和有关金融法规确定。
        　　 <br />
        <br />
        第一百八十七条　银行或者其他金融机构的工作人员以牟利为目的，采取吸收客户资金不入帐的方式，将资金用于非法拆借、发放贷款，造成重大损失的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；造成特别重大损失的，处五年以上有期徒刑，并处五万元以上五十万元以下罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百八十八条　银行或者其他金融机构的工作人员违反规定，为他人出具信用证或者其他保函、票据、存单、资信证明，造成较大损失的，处五年以下有期徒刑或者拘役；造成重大损失的，处五年以上有期徒刑。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百八十九条　银行或者其他金融机构的工作人员在票据业务中，对违反票据法规定的票据予以承兑、付款或者保证，造成重大损失的，处五年以下有期徒刑或者拘役；造成特别重大损失的，处五年以上有期徒刑。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百九十条　国有公司、企业或者其他国有单位，违反国家规定，擅自将外汇存放境外，或者将境内的外汇非法转移到境外，情节严重的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第一百九十一条　明知是毒品犯罪、黑社会性质的组织犯罪、走私犯罪的违法所得及其产生的收益，为掩饰、隐瞒其来源和性质，有下列行为之一的，没收实施以上犯罪的违法所得及其产生的收益，处五年以下有期徒刑或者拘役，并处或者单处洗钱数额百分之五以上百分之二十以下罚金；情节严重的，处五年以上十年以下有期徒刑，并处洗钱数额百分之五以上百分之二十以下罚金：
        　　 <br />
        <br />
        （一）提供资金账户的； 　　 <br />
        <br />
        （二）协助将财产转换为现金或者金融票据的； 　　 <br />
        <br />
        （三）通过转账或者其他结算方式协助资金转移的； 　　 <br />
        <br />
        （四）协助将资金汇往境外的； 　　 <br />
        <br />
        （五）以其他方法掩饰、隐瞒犯罪的违法所得及其收益的性质和来源的。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        <br />
        <br />
        第五节　金融诈骗罪 　　 <br />
        <br />
        第一百九十二条　以非法占有为目的，使用诈骗方法非法集资，数额较大的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百九十三条　有下列情形之一，以非法占有为目的，诈骗银行或者其他金融机构的贷款，数额较大的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）编造引进资金、项目等虚假理由的； 　　 <br />
        <br />
        （二）使用虚假的经济合同的； 　　 <br />
        <br />
        （三）使用虚假的证明文件的； 　　 <br />
        <br />
        （四）使用虚假的产权证明作担保或者超出抵押物价值重复担保的； 　　 <br />
        <br />
        （五）以其他方法诈骗贷款的。 　　 <br />
        <br />
        第一百九十四条　有下列情形之一，进行金融票据诈骗活动，数额较大的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）明知是伪造、变造的汇票、本票、支票而使用的； 　　 <br />
        <br />
        （二）明知是作废的汇票、本票、支票而使用的； 　　 <br />
        <br />
        （三）冒用他人的汇票、本票、支票的； 　　 <br />
        <br />
        （四）签发空头支票或者与其预留印鉴不符的支票，骗取财物的； 　　 <br />
        <br />
        （五）汇票、本票的出票人签发无资金保证的汇票、本票或者在出票时作虚假记载，骗取财物的。
        　　使用伪造、变造的委托收款凭证、汇款凭证、银行存单等其他银行结算凭证的，依照前款的规定处罚。
        　　 <br />
        <br />
        第一百九十五条　有下列情形之一，进行信用证诈骗活动的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）使用伪造、变造的信用证或者附随的单据、文件的； 　　 <br />
        <br />
        （二）使用作废的信用证的； 　　 <br />
        <br />
        （三）骗取信用证的； 　　 <br />
        <br />
        （四）以其他方法进行信用证诈骗活动的。 　　 <br />
        <br />
        第一百九十六条　有下列情形之一，进行信用卡诈骗活动，数额较大的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）使用伪造的信用卡的； 　　 <br />
        <br />
        （二）使用作废的信用卡的； 　　 <br />
        <br />
        （三）冒用他人信用卡的； 　　 <br />
        <br />
        （四）恶意透支的。
        　　前款所称恶意透支，是指持卡人以非法占有为目的，超过规定限额或者规定期限透支，并且经发卡银行催收后仍不归还的行为。
        　　盗窃信用卡并使用的，依照本法 <br />
        <br />
        第二百六十四条的规定定罪处罚。 　　 <br />
        <br />
        第一百九十七条　使用伪造、变造的国库券或者国家发行的其他有价证券，进行诈骗活动，数额较大的，处五年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　 <br />
        <br />
        第一百九十八条　有下列情形之一，进行保险诈骗活动，数额较大的，处五年以下有期徒刑或者拘役，并处一万元以上十万元以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处二万元以上二十万元以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑，并处二万元以上二十万元以下罚金或者没收财产：
        　　 <br />
        <br />
        （一）投保人故意虚构保险标的，骗取保险金的； 　　 <br />
        <br />
        （二）投保人、被保险人或者受益人对发生的保险事故编造虚假的原因或者夸大损失的程度，骗取保险金的；
        　　 <br />
        <br />
        （三）投保人、被保险人或者受益人编造未曾发生的保险事故，骗取保险金的；
        　　 <br />
        <br />
        （四）投保人、被保险人故意造成财产损失的保险事故，骗取保险金的； 　　{" "}
        <br />
        <br />
        （五）投保人、受益人故意造成被保险人死亡、伤残或者疾病，骗取保险金的。
        　　有前款 <br />
        <br />
        第四项、 <br />
        <br />
        第五项所列行为，同时构成其他犯罪的，依照数罪并罚的规定处罚。 　　单位犯{" "}
        <br />
        <br />
        第一款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑。
        　　保险事故的鉴定人、证明人、财产评估人故意提供虚假的证明文件，为他人诈骗提供条件的，以保险诈骗的共犯论处。
        　　 <br />
        <br />
        第一百九十九条　犯本节 <br />
        <br />
        第一百九十二条、 <br />
        <br />
        第一百九十四条、 <br />
        <br />
        第一百九十五条规定之罪，数额特别巨大并且给国家和人民利益造成特别重大损失的，处无期徒刑或者死刑，并处没收财产。
        　　 <br />
        <br />
        第二百条　单位犯本节 <br />
        <br />
        第一百九十二条、 <br />
        <br />
        第一百九十四条、 <br />
        <br />
        第一百九十五条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑。
        <br />
        <br />
        第六节　危害税收征管罪 　　 <br />
        <br />
        第二百零一条　纳税人采取伪造、变造、隐匿、擅自销毁帐簿、记帐凭证，在帐簿上多列支出或者不列、少列收入，经税务机关通知申报而拒不申报或者进行虚假的纳税申报的手段，不缴或者少缴应纳税款，偷税数额占应纳税额的百分之十以上不满百分之三十并且偷税数额在一万元以上不满十万元的，或者因偷税被税务机关给予二次行政处罚又偷税的，处三年以下有期徒刑或者拘役，并处偷税数额一倍以上五倍以下罚金；偷税数额占应纳税额的百分之三十以上并且偷税数额在十万元以上的，处三年以上七年以下有期徒刑，并处偷税数额一倍以上五倍以下罚金。
        　　扣缴义务人采取前款所列手段，不缴或者少缴已扣、已收税款，数额占应缴税额的百分之十以上并且数额在一万元以上的，依照前款的规定处罚。
        　　对多次犯有前两款行为，未经处理的，按照累计数额计算。 　　 <br />
        <br />
        第二百零二条　以暴力、威胁方法拒不缴纳税款的，处三年以下有期徒刑或者拘役，并处拒缴税款一倍以上五倍以下罚金；情节严重的，处三年以上七年以下有期徒刑，并处拒缴税款一倍以上五倍以下罚金。
        　　 <br />
        <br />
        第二百零三条　纳税人欠缴应纳税款，采取转移或者隐匿财产的手段，致使税务机关无法追缴欠缴的税款，数额在一万元以上不满十万元的，处三年以下有期徒刑或者拘役，并处或者单处欠缴税款一倍以上五倍以下罚金；数额在十万元以上的，处三年以上七年以下有期徒刑，并处欠缴税款一倍以上五倍以下罚金。
        　　 <br />
        <br />
        第二百零四条　以假报出口或者其他欺骗手段，骗取国家出口退税款，数额较大的，处五年以下有期徒刑或者拘役，并处骗取税款一倍以上五倍以下罚金；数额巨大或者有其他严重情节的，处五年以上十年以下有期徒刑，并处骗取税款一倍以上五倍以下罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处骗取税款一倍以上五倍以下罚金或者没收财产。
        　　纳税人缴纳税款后，采取前款规定的欺骗方法，骗取所缴纳的税款的，依照本法{" "}
        <br />
        <br />
        第二百零一条的规定定罪处罚；骗取税款超过所缴纳的税款部分，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百零五条　虚开增值税专用发票或者虚开用于骗取出口退税、抵扣税款的其他发票的，处三年以下有期徒刑或者拘役，并处二万元以上二十万元以下罚金；虚开的税款数额较大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；虚开的税款数额巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　有前款行为骗取国家税款，数额特别巨大，情节特别严重，给国家利益造成特别重大损失的，处无期徒刑或者死刑，并处没收财产。
        　　单位犯本条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役；虚开的税款数额较大或者有其他严重情节的，处三年以上十年以下有期徒刑；虚开的税款数额巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑。
        　　虚开增值税专用发票或者虚开用于骗取出口退税、抵扣税款的其他发票，是指有为他人虚开、为自己虚开、让他人为自己虚开、介绍他人虚开行为之一的。
        　　 <br />
        <br />
        第二百零六条　伪造或者出售伪造的增值税专用发票的，处三年以下有期徒刑、拘役或者管制，并处二万元以上二十万元以下罚金；数量较大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数量巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　伪造并出售伪造的增值税专用发票，数量特别巨大，情节特别严重，严重破坏经济秩序的，处无期徒刑或者死刑，并处没收财产。
        　　单位犯本条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑、拘役或者管制；数量较大或者有其他严重情节的，处三年以上十年以下有期徒刑；数量巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑。
        　　 <br />
        <br />
        第二百零七条　非法出售增值税专用发票的，处三年以下有期徒刑、拘役或者管制，并处二万元以上二十万元以下罚金；数量较大的，处三年以上十年以下有期徒刑，并处五万元以上五十万元以下罚金；数量巨大的，处十年以上有期徒刑或者无期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　 <br />
        <br />
        第二百零八条　非法购买增值税专用发票或者购买伪造的增值税专用发票的，处五年以下有期徒刑或者拘役，并处或者单处二万元以上二十万元以下罚金。
        　　非法购买增值税专用发票或者购买伪造的增值税专用发票又虚开或者出售的，分别依照本法{" "}
        <br />
        <br />
        第二百零五条、 <br />
        <br />
        第二百零六条、 <br />
        <br />
        第二百零七条的规定定罪处罚。 　　 <br />
        <br />
        第二百零九条　伪造、擅自制造或者出售伪造、擅自制造的可以用于骗取出口退税、抵扣税款的其他发票的，处三年以下有期徒刑、拘役或者管制，并处二万元以上二十万元以下罚金；数量巨大的，处三年以上七年以下有期徒刑，并处五万元以上五十万元以下罚金；数量特别巨大的，处七年以上有期徒刑，并处五万元以上五十万元以下罚金或者没收财产。
        　　伪造、擅自制造或者出售伪造、擅自制造的前款规定以外的其他发票的，处二年以下有期徒刑、拘役或者管制，并处或者单处一万元以上五万元以下罚金；情节严重的，处二年以上七年以下有期徒刑，并处五万元以上五十万元以下罚金。
        　　非法出售可以用于骗取出口退税、抵扣税款的其他发票的，依照 <br />
        <br />
        第一款的规定处罚。 　　非法出售 <br />
        <br />
        第三款规定以外的其他发票的，依照 <br />
        <br />
        第二款的规定处罚。 　　 <br />
        <br />
        第二百一十条　盗窃增值税专用发票或者可以用于骗取出口退税、抵扣税款的其他发票的，依照本法{" "}
        <br />
        <br />
        第二百六十四条的规定定罪处罚。
        　　使用欺骗手段骗取增值税专用发票或者可以用于骗取出口退税、抵扣税款的其他发票的，依照本法{" "}
        <br />
        <br />
        第二百六十六条的规定定罪处罚。 　　 <br />
        <br />
        第二百一十一条　单位犯本节 <br />
        <br />
        第二百零一条、 <br />
        <br />
        第二百零三条、 <br />
        <br />
        第二百零四条、 <br />
        <br />
        第二百零七条、 <br />
        <br />
        第二百零八条、 <br />
        <br />
        第二百零九条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照各该条的规定处罚。
        　　 <br />
        <br />
        第二百一十二条　犯本节 <br />
        <br />
        第二百零一条至 <br />
        <br />
        第二百零五条规定之罪，被判处罚金、没收财产的，在执行前，应当先由税务机关追缴税款和所骗取的出口退税款。
        <br />
        <br />
        第七节　侵犯知识产权罪 　　 <br />
        <br />
        第二百一十三条　未经注册商标所有人许可，在同一种商品上使用与其注册商标相同的商标，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金；情节特别严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第二百一十四条　销售明知是假冒注册商标的商品，销售金额数额较大的，处三年以下有期徒刑或者拘役，并处或者单处罚金；销售金额数额巨大的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第二百一十五条　伪造、擅自制造他人注册商标标识或者销售伪造、擅自制造的注册商标标识，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；情节特别严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第二百一十六条　假冒他人专利，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百一十七条　以营利为目的，有下列侵犯著作权情形之一，违法所得数额较大或者有其他严重情节的，处三年以下有期徒刑或者拘役，并处或者单处罚金；违法所得数额巨大或者有其他特别严重情节的，处三年以上七年以下有期徒刑，并处罚金：
        　　 <br />
        <br />
        （一）未经著作权人许可，复制发行其文字作品、音乐、电影、电视、录像作品、计算机软件及其他作品的；
        　　 <br />
        <br />
        （二）出版他人享有专有出版权的图书的； 　　 <br />
        <br />
        （三）未经录音录像制作者许可，复制发行其制作的录音录像的； 　　 <br />
        <br />
        （四）制作、出售假冒他人署名的美术作品的。 　　 <br />
        <br />
        第二百一十八条　以营利为目的，销售明知是本法 <br />
        <br />
        第二百一十七条规定的侵权复制品，违法所得数额巨大的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百一十九条　有下列侵犯商业秘密行为之一，给商业秘密的权利人造成重大损失的，处三年以下有期徒刑或者拘役，并处或者单处罚金；造成特别严重后果的，处三年以上七年以下有期徒刑，并处罚金：
        　　 <br />
        <br />
        （一）以盗窃、利诱、胁迫或者其他不正当手段获取权利人的商业秘密的； 　　{" "}
        <br />
        <br />
        （二）披露、使用或者允许他人使用以前项手段获取的权利人的商业秘密的；
        　　 <br />
        <br />
        （三）违反约定或者违反权利人有关保守商业秘密的要求，披露、使用或者允许他人使用其所掌握的商业秘密的。
        　　明知或者应知前款所列行为，获取、使用或者披露他人的商业秘密的，以侵犯商业秘密论。
        　　本条所称商业秘密，是指不为公众所知悉，能为权利人带来经济利益，具有实用性并经权利人采取保密措施的技术信息和经营信息。
        　　本条所称权利人，是指商业秘密的所有人和经商业秘密所有人许可的商业秘密使用人。
        　　 <br />
        <br />
        第二百二十条　单位犯本节 <br />
        <br />
        第二百一十三条至 <br />
        <br />
        第二百一十九条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照本节各该条的规定处罚。
        <br />
        <br />
        第八节　扰乱市场秩序罪 　　 <br />
        <br />
        第二百二十一条　捏造并散布虚伪事实，损害他人的商业信誉、商品声誉，给他人造成重大损失或者有其他严重情节的，处二年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百二十二条　广告主、广告经营者、广告发布者违反国家规定，利用广告对商品或者服务作虚假宣传，情节严重的，处二年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百二十三条　投标人相互串通投标报价，损害招标人或者其他投标人利益，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　投标人与招标人串通投标，损害国家、集体、公民的合法利益的，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百二十四条　有下列情形之一，以非法占有为目的，在签订、履行合同过程中，骗取对方当事人财物，数额较大的，处三年以下有期徒刑或者拘役，并处或者单处罚金；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产：
        　　 <br />
        <br />
        （一）以虚构的单位或者冒用他人名义签订合同的； 　　 <br />
        <br />
        （二）以伪造、变造、作废的票据或者其他虚假的产权证明作担保的； 　　{" "}
        <br />
        <br />
        （三）没有实际履行能力，以先履行小额合同或者部分履行合同的方法，诱骗对方当事人继续签订和履行合同的；
        　　 <br />
        <br />
        （四）收受对方当事人给付的货物、货款、预付款或者担保财产后逃匿的； 　　{" "}
        <br />
        <br />
        （五）以其他方法骗取对方当事人财物的。 　　 <br />
        <br />
        第二百二十五条　违反国家规定，有下列非法经营行为之一，扰乱市场秩序，情节严重的，处五年以下有期徒刑或者拘役，并处或者单处违法所得一倍以上五倍以下罚金；情节特别严重的，处五年以上有期徒刑，并处违法所得一倍以上五倍以下罚金或者没收财产:
        　　 <br />
        <br />
        （一）未经许可经营法律、行政法规规定的专营、专卖物品或者其他限制买卖的物品的；
        　　 <br />
        <br />
        （二）买卖进出口许可证、进出口原产地证明以及其他法律、行政法规规定的经营许可证或者批准文件的；
        　　 <br />
        <br />
        （三）其他严重扰乱市场秩序的非法经营行为。 　　 <br />
        <br />
        第二百二十六条　以暴力、威胁手段强买强卖商品、强迫他人提供服务或者强迫他人接受服务，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百二十七条　伪造或者倒卖伪造的车票、船票、邮票或者其他有价票证，数额较大的，处二年以下有期徒刑、拘役或者管制，并处或者单处票证价额一倍以上五倍以下罚金；数额巨大的，处二年以上七年以下有期徒刑，并处票证价额一倍以上五倍以下罚金。
        　　倒卖车票、船票，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处票证价额一倍以上五倍以下罚金。
        　　 <br />
        <br />
        第二百二十八条　以牟利为目的，违反土地管理法规，非法转让、倒卖土地使用权，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处非法转让、倒卖土地使用权价额百分之五以上百分之二十以下罚金；情节特别严重的，处三年以上七年以下有期徒刑，并处非法转让、倒卖土地使用权价额百分之五以上百分之二十以下罚金。
        　　 <br />
        <br />
        第二百二十九条　承担资产评估、验资、验证、会计、审计、法律服务等职责的中介组织的人员故意提供虚假证明文件，情节严重的，处五年以下有期徒刑或者拘役，并处罚金。
        　　前款规定的人员，索取他人财物或者非法收受他人财物，犯前款罪的，处五年以上十年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第一款规定的人员，严重不负责任，出具的证明文件有重大失实，造成严重后果的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百三十条　违反进出口商品检验法的规定，逃避商品检验，将必须经商检机构检验的进口商品未报经检验而擅自销售、使用，或者将必须经商检机构检验的出口商品未报经检验合格而擅自出口，情节严重的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百三十一条　单位犯本节 <br />
        <br />
        第二百二十一条至 <br />
        <br />
        第二百三十条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照本节各该条的规定处罚。
        <br />
        <br />
        第四章　侵犯公民人身权利、民主权利罪 　　 <br />
        <br />
        第二百三十二条　故意杀人的，处死刑、无期徒刑或者十年以上有期徒刑；情节较轻的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第二百三十三条　过失致人死亡的，处三年以上七年以下有期徒刑；情节较轻的，处三年以下有期徒刑。本法另有规定的，依照规定。
        　　 <br />
        <br />
        第二百三十四条　故意伤害他人身体的，处三年以下有期徒刑、拘役或者管制。
        　　犯前款罪，致人重伤的，处三年以上十年以下有期徒刑；致人死亡或者以特别残忍手段致人重伤造成严重残疾的，处十年以上有期徒刑、无期徒刑或者死刑。本法另有规定的，依照规定。
        　　 <br />
        <br />
        第二百三十五条　过失伤害他人致人重伤的，处三年以下有期徒刑或者拘役。本法另有规定的，依照规定。
        　　 <br />
        <br />
        第二百三十六条　以暴力、胁迫或者其他手段强奸妇女的，处三年以上十年以下有期徒刑。
        　　奸淫不满十四周岁的幼女的，以强奸论，从重处罚。
        　　强奸妇女、奸淫幼女，有下列情形之一的，处十年以上有期徒刑、无期徒刑或者死刑:
        　　 <br />
        <br />
        （一）强奸妇女、奸淫幼女情节恶劣的； 　　 <br />
        <br />
        （二）强奸妇女、奸淫幼女多人的； 　　 <br />
        <br />
        （三）在公共场所当众强奸妇女的； 　　 <br />
        <br />
        （四）二人以上轮奸的； 　　 <br />
        <br />
        （五）致使被害人重伤、死亡或者造成其他严重后果的。 　　 <br />
        <br />
        第二百三十七条　以暴力、胁迫或者其他方法强制猥亵妇女或者侮辱妇女的，处五年以下有期徒刑或者拘役。
        　　聚众或者在公共场所当众犯前款罪的，处五年以上有期徒刑。
        　　猥亵儿童的，依照前两款的规定从重处罚。 　　 <br />
        <br />
        第二百三十八条　非法拘禁他人或者以其他方法非法剥夺他人人身自由的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。具有殴打、侮辱情节的，从重处罚。
        　　犯前款罪，致人重伤的，处三年以上十年以下有期徒刑；致人死亡的，处十年以上有期徒刑。使用暴力致人伤残、死亡的，依照本法{" "}
        <br />
        <br />
        第二百三十四条、 <br />
        <br />
        第二百三十二条的规定定罪处罚。
        　　为索取债务非法扣押、拘禁他人的，依照前两款的规定处罚。
        　　国家机关工作人员利用职权犯前三款罪的，依照前三款的规定从重处罚。
        　　 <br />
        <br />
        第二百三十九条　以勒索财物为目的绑架他人的，或者绑架他人作为人质的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产；致使被绑架人死亡或者杀害被绑架人的，处死刑，并处没收财产。
        　　以勒索财物为目的偷盗婴幼儿的，依照前款的规定处罚。 　　 <br />
        <br />
        第二百四十条　拐卖妇女、儿童的，处五年以上十年以下有期徒刑，并处罚金；有下列情形之一的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产；情节特别严重的，处死刑，并处没收财产:
        　　 <br />
        <br />
        （一）拐卖妇女、儿童集团的首要分子； 　　 <br />
        <br />
        （二）拐卖妇女、儿童三人以上的； 　　 <br />
        <br />
        （三）奸淫被拐卖的妇女的； 　　 <br />
        <br />
        （四）诱骗、强迫被拐卖的妇女卖淫或者将被拐卖的妇女卖给他人迫使其卖淫的；
        　　 <br />
        <br />
        （五）以出卖为目的，使用暴力、胁迫或者麻醉方法绑架妇女、儿童的； 　　{" "}
        <br />
        <br />
        （六）以出卖为目的，偷盗婴幼儿的； 　　 <br />
        <br />
        （七）造成被拐卖的妇女、儿童或者其亲属重伤、死亡或者其他严重后果的；
        　　 <br />
        <br />
        （八）将妇女、儿童卖往境外的。
        　　拐卖妇女、儿童是指以出卖为目的，有拐骗、绑架、收买、贩卖、接送、中转妇女、儿童的行为之一的。
        　　 <br />
        <br />
        第二百四十一条　收买被拐卖的妇女、儿童的，处三年以下有期徒刑、拘役或者管制。
        　　收买被拐卖的妇女，强行与其发生性关系的，依照本法 <br />
        <br />
        第二百三十六条的规定定罪处罚。
        　　收买被拐卖的妇女、儿童，非法剥夺、限制其人身自由或者有伤害、侮辱等犯罪行为的，依照本法的有关规定定罪处罚。
        　　收买被拐卖的妇女、儿童，并有 <br />
        <br />
        第二款、 <br />
        <br />
        第三款规定的犯罪行为的，依照数罪并罚的规定处罚。
        　　收买被拐卖的妇女、儿童又出卖的，依照本法 <br />
        <br />
        第二百四十条的规定定罪处罚。
        　　收买被拐卖的妇女、儿童，按照被买妇女的意愿，不阻碍其返回原居住地的，对被买儿童没有虐待行为，不阻碍对其进行解救的，可以不追究刑事责任。
        　　 <br />
        <br />
        第二百四十二条　以暴力、威胁方法阻碍国家机关工作人员解救被收买的妇女、儿童的，依照本法{" "}
        <br />
        <br />
        第二百七十七条的规定定罪处罚。
        　　聚众阻碍国家机关工作人员解救被收买的妇女、儿童的首要分子，处五年以下有期徒刑或者拘役；其他参与者使用暴力、威胁方法的，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百四十三条　捏造事实诬告陷害他人，意图使他人受刑事追究，情节严重的，处三年以下有期徒刑、拘役或者管制；造成严重后果的，处三年以上十年以下有期徒刑。
        　　国家机关工作人员犯前款罪的，从重处罚。
        　　不是有意诬陷，而是错告，或者检举失实的，不适用前两款的规定。 　　{" "}
        <br />
        <br />
        第二百四十四条　用人单位违反劳动管理法规，以限制人身自由方法强迫职工劳动，情节严重的，对直接责任人员，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第二百四十五条　非法搜查他人身体、住宅，或者非法侵入他人住宅的，处三年以下有期徒刑或者拘役。
        　　司法工作人员滥用职权，犯前款罪的，从重处罚。 　　 <br />
        <br />
        第二百四十六条　以暴力或者其他方法公然侮辱他人或者捏造事实诽谤他人，情节严重的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　前款罪，告诉的才处理，但是严重危害社会秩序和国家利益的除外。 　　{" "}
        <br />
        <br />
        第二百四十七条　司法工作人员对犯罪嫌疑人、被告人实行刑讯逼供或者使用暴力逼取证人证言的，处三年以下有期徒刑或者拘役。致人伤残、死亡的，依照本法{" "}
        <br />
        <br />
        第二百三十四条、 <br />
        <br />
        第二百三十二条的规定定罪从重处罚。 　　 <br />
        <br />
        第二百四十八条　监狱、拘留所、看守所等监管机构的监管人员对被监管人进行殴打或者体罚虐待，情节严重的，处三年以下有期徒刑或者拘役；情节特别严重的，处三年以上十年以下有期徒刑。致人伤残、死亡的，依照本法{" "}
        <br />
        <br />
        第二百三十四条、 <br />
        <br />
        第二百三十二条的规定定罪从重处罚。
        　　监管人员指使被监管人殴打或者体罚虐待其他被监管人的，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百四十九条　煽动民族仇恨、民族歧视，情节严重的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节特别严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第二百五十条　在出版物中刊载歧视、侮辱少数民族的内容，情节恶劣，造成严重后果的，对直接责任人员，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百五十一条　国家机关工作人员非法剥夺公民的宗教信仰自由和侵犯少数民族风俗习惯，情节严重的，处二年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第二百五十二条　隐匿、毁弃或者非法开拆他人信件，侵犯公民通信自由权利，情节严重的，处一年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第二百五十三条　邮政工作人员私自开拆或者隐匿、毁弃邮件、电报的，处二年以下有期徒刑或者拘役。
        　　犯前款罪而窃取财物的，依照本法 <br />
        <br />
        第二百六十四条的规定定罪从重处罚。 　　 <br />
        <br />
        第二百五十四条　国家机关工作人员滥用职权、假公济私，对控告人、申诉人、批评人、举报人实行报复陷害的，处二年以下有期徒刑或者拘役；情节严重的，处二年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第二百五十五条　公司、企业、事业单位、机关、团体的领导人，对依法履行职责、抵制违反会计法、统计法行为的会计、统计人员实行打击报复，情节恶劣的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第二百五十六条　在选举各级人民代表大会代表和国家机关领导人员时，以暴力、威胁、欺骗、贿赂、伪造选举文件、虚报选举票数等手段破坏选举或者妨害选民和代表自由行使选举权和被选举权，情节严重的，处三年以下有期徒刑、拘役或者剥夺政治权利。
        　　 <br />
        <br />
        第二百五十七条　以暴力干涉他人婚姻自由的，处二年以下有期徒刑或者拘役。
        　　犯前款罪，致使被害人死亡的，处二年以上七年以下有期徒刑。 　　 <br />
        <br />
        第一款罪，告诉的才处理。 　　 <br />
        <br />
        第二百五十八条　有配偶而重婚的，或者明知他人有配偶而与之结婚的，处二年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第二百五十九条　明知是现役军人的配偶而与之同居或者结婚的，处三年以下有期徒刑或者拘役。
        　　利用职权、从属关系，以胁迫手段奸淫现役军人的妻子的，依照本法 <br />
        <br />
        第二百三十六条的规定定罪处罚。 　　 <br />
        <br />
        第二百六十条　虐待家庭成员，情节恶劣的，处二年以下有期徒刑、拘役或者管制。
        　　犯前款罪，致使被害人重伤、死亡的，处二年以上七年以下有期徒刑。 　　{" "}
        <br />
        <br />
        第一款罪，告诉的才处理。 　　 <br />
        <br />
        第二百六十一条　对于年老、年幼、患病或者其他没有独立生活能力的人，负有扶养义务而拒绝扶养，情节恶劣的，处五年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百六十二条　拐骗不满十四周岁的未成年人，脱离家庭或者监护人的，处五年以下有期徒刑或者拘役。
        <br />
        <br />
        第五章　侵犯财产罪 　　 <br />
        <br />
        第二百六十三条　以暴力、胁迫或者其他方法抢劫公私财物的，处三年以上十年以下有期徒刑，并处罚金；有下列情形之一的，处十年以上有期徒刑、无期徒刑或者死刑，并处罚金或者没收财产:
        　　 <br />
        <br />
        （一）入户抢劫的； 　　 <br />
        <br />
        （二）在公共交通工具上抢劫的； 　　 <br />
        <br />
        （三）抢劫银行或者其他金融机构的； 　　 <br />
        <br />
        （四）多次抢劫或者抢劫数额巨大的； 　　 <br />
        <br />
        （五）抢劫致人重伤、死亡的； 　　 <br />
        <br />
        （六）冒充军警人员抢劫的； 　　 <br />
        <br />
        （七）持枪抢劫的； 　　 <br />
        <br />
        （八）抢劫军用物资或者抢险、救灾、救济物资的。 　　 <br />
        <br />
        第二百六十四条　盗窃公私财物，数额较大或者多次盗窃的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产；有下列情形之一的，处无期徒刑或者死刑，并处没收财产：
        　　 <br />
        <br />
        （一）盗窃金融机构，数额特别巨大的； 　　 <br />
        <br />
        （二）盗窃珍贵文物，情节严重的。 　　 <br />
        <br />
        第二百六十五条　以牟利为目的，盗接他人通信线路、复制他人电信码号或者明知是盗接、复制的电信设备、设施而使用的，依照本法{" "}
        <br />
        <br />
        第二百六十四条的规定定罪处罚。 　　 <br />
        <br />
        第二百六十六条　诈骗公私财物，数额较大的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产。本法另有规定的，依照规定。
        　　 <br />
        <br />
        第二百六十七条　抢夺公私财物，数额较大的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑，并处罚金；数额特别巨大或者有其他特别严重情节的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产。
        　　携带凶器抢夺的，依照本法 <br />
        <br />
        第二百六十三条的规定定罪处罚。 　　 <br />
        <br />
        第二百六十八条　聚众哄抢公私财物，数额较大或者有其他严重情节的，对首要分子和积极参加的，处三年以下有期徒刑、拘役或者管制，并处罚金；数额巨大或者有其他特别严重情节的，处三年以上十年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第二百六十九条　犯盗窃、诈骗、抢夺罪，为窝藏赃物、抗拒抓捕或者毁灭罪证而当场使用暴力或者以暴力相威胁的，依照本法{" "}
        <br />
        <br />
        第二百六十三条的规定定罪处罚。 　　 <br />
        <br />
        第二百七十条　将代为保管的他人财物非法占为己有，数额较大，拒不退还的，处二年以下有期徒刑、拘役或者罚金；数额巨大或者有其他严重情节的，处二年以上五年以下有期徒刑，并处罚金。
        　　将他人的遗忘物或者埋藏物非法占为己有，数额较大，拒不交出的，依照前款的规定处罚。
        　　本条罪，告诉的才处理。 　　 <br />
        <br />
        第二百七十一条　公司、企业或者其他单位的人员，利用职务上的便利，将本单位财物非法占为己有，数额较大的，处五年以下有期徒刑或者拘役；数额巨大的，处五年以上有期徒刑，可以并处没收财产。
        　　国有公司、企业或者其他国有单位中从事公务的人员和国有公司、企业或者其他国有单位委派到非国有公司、企业以及其他单位从事公务的人员有前款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十二条、 <br />
        <br />
        第三百八十三条的规定定罪处罚。 　　 <br />
        <br />
        第二百七十二条　公司、企业或者其他单位的工作人员，利用职务上的便利，挪用本单位资金归个人使用或者借贷给他人，数额较大、超过三个月未还的，或者虽未超过三个月，但数额较大、进行营利活动的，或者进行非法活动的，处三年以下有期徒刑或者拘役；挪用本单位资金数额巨大的，或者数额较大不退还的，处三年以上十年以下有期徒刑。
        　　国有公司、企业或者其他国有单位中从事公务的人员和国有公司、企业或者其他国有单位委派到非国有公司、企业以及其他单位从事公务的人员有前款行为的，依照本法{" "}
        <br />
        <br />
        第三百八十四条的规定定罪处罚。 　　 <br />
        <br />
        第二百七十三条　挪用用于救灾、抢险、防汛、优抚、扶贫、移民、救济款物，情节严重，致使国家和人民群众利益遭受重大损害的，对直接责任人员，处三年以下有期徒刑或者拘役；情节特别严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第二百七十四条　敲诈勒索公私财物，数额较大的，处三年以下有期徒刑、拘役或者管制；数额巨大或者有其他严重情节的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第二百七十五条　故意毁坏公私财物，数额较大或者有其他严重情节的，处三年以下有期徒刑、拘役或者罚金；数额巨大或者有其他特别严重情节的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第二百七十六条　由于泄愤报复或者其他个人目的，毁坏机器设备、残害耕畜或者以其他方法破坏生产经营的，处三年以下有期徒刑、拘役或者管制；情节严重的，处三年以上七年以下有期徒刑。
        <br />
        <br />
        第六章　妨害社会管理秩序罪 <br />
        <br />
        第一节　扰乱公共秩序罪 　　 <br />
        <br />
        第二百七十七条　以暴力、威胁方法阻碍国家机关工作人员依法执行职务的，处三年以下有期徒刑、拘役、管制或者罚金。
        　　以暴力、威胁方法阻碍全国人民代表大会和地方各级人民代表大会代表依法执行代表职务的，依照前款的规定处罚。
        　　在自然灾害和突发事件中，以暴力、威胁方法阻碍红十字会工作人员依法履行职责的，依照{" "}
        <br />
        <br />
        第一款的规定处罚。
        　　故意阻碍国家安全机关、公安机关依法执行国家安全工作任务，未使用暴力、威胁方法，造成严重后果的，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第二百七十八条　煽动群众暴力抗拒国家法律、行政法规实施的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；造成严重后果的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第二百七十九条　冒充国家机关工作人员招摇撞骗的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上十年以下有期徒刑。
        　　冒充人民警察招摇撞骗的，依照前款的规定从重处罚。 　　 <br />
        <br />
        第二百八十条　伪造、变造、买卖或者盗窃、抢夺、毁灭国家机关的公文、证件、印章的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上十年以下有期徒刑。
        　　伪造公司、企业、事业单位、人民团体的印章的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　伪造、变造居民身份证的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第二百八十一条　非法生产、买卖人民警察制式服装、车辆号牌等专用标志、警械，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百八十二条　以窃取、刺探、收买方法，非法获取国家秘密的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上七年以下有期徒刑。
        　　非法持有属于国家绝密、机密的文件、资料或者其他物品，拒不说明来源与用途的，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百八十三条　非法生产、销售窃听、窃照等专用间谍器材的，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百八十四条　非法使用窃听、窃照专用器材，造成严重后果的，处二年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百八十五条　违反国家规定，侵入国家事务、国防建设、尖端科学技术领域的计算机信息系统的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第二百八十六条　违反国家规定，对计算机信息系统功能进行删除、修改、增加、干扰，造成计算机信息系统不能正常运行，后果严重的，处五年以下有期徒刑或者拘役；后果特别严重的，处五年以上有期徒刑。
        　　违反国家规定，对计算机信息系统中存储、处理或者传输的数据和应用程序进行删除、修改、增加的操作，后果严重的，依照前款的规定处罚。
        　　故意制作、传播计算机病毒等破坏性程序，影响计算机系统正常运行，后果严重的，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第二百八十七条　利用计算机实施金融诈骗、盗窃、贪污、挪用公款、窃取国家秘密或者其他犯罪的，依照本法有关规定定罪处罚。
        　　 <br />
        <br />
        第二百八十八条　违反国家规定，擅自设置、使用无线电台 <br />
        <br />
        （站），或者擅自占用频率，经责令停止使用后拒不停止使用，干扰无线电通讯正常进行，造成严重后果的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第二百八十九条　聚众“打砸抢”，致人伤残、死亡的，依照本法 <br />
        <br />
        第二百三十四条、 <br />
        <br />
        第二百三十二条的规定定罪处罚。毁坏或者抢走公私财物的，除判令退赔外，对首要分子，依照本法{" "}
        <br />
        <br />
        第二百六十三条的规定定罪处罚。 　　 <br />
        <br />
        第二百九十条　聚众扰乱社会秩序，情节严重，致使工作、生产、营业和教学、科研无法进行，造成严重损失的，对首要分子，处三年以上七年以下有期徒刑；对其他积极参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　聚众冲击国家机关，致使国家机关工作无法进行，造成严重损失的，对首要分子，处五年以上十年以下有期徒刑；对其他积极参加的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第二百九十一条　聚众扰乱车站、码头、民用航空站、商场、公园、影剧院、展览会、运动场或者其他公共场所秩序，聚众堵塞交通或者破坏交通秩序，抗拒、阻碍国家治安管理工作人员依法执行职务，情节严重的，对首要分子，处五年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第二百九十二条　聚众斗殴的，对首要分子和其他积极参加的，处三年以下有期徒刑、拘役或者管制；有下列情形之一的，对首要分子和其他积极参加的，处三年以上十年以下有期徒刑:
        　　 <br />
        <br />
        （一）多次聚众斗殴的； 　　 <br />
        <br />
        （二）聚众斗殴人数多，规模大，社会影响恶劣的； 　　 <br />
        <br />
        （三）在公共场所或者交通要道聚众斗殴，造成社会秩序严重混乱的； 　　{" "}
        <br />
        <br />
        （四）持械聚众斗殴的。 　　聚众斗殴，致人重伤、死亡的，依照本法 <br />
        <br />
        第二百三十四条、 <br />
        <br />
        第二百三十二条的规定定罪处罚。 　　 <br />
        <br />
        第二百九十三条　有下列寻衅滋事行为之一，破坏社会秩序的，处五年以下有期徒刑、拘役或者管制:
        　　 <br />
        <br />
        （一）随意殴打他人，情节恶劣的； 　　 <br />
        <br />
        （二）追逐、拦截、辱骂他人，情节恶劣的； 　　 <br />
        <br />
        （三）强拿硬要或者任意损毁、占用公私财物，情节严重的； 　　 <br />
        <br />
        （四）在公共场所起哄闹事，造成公共场所秩序严重混乱的。 　　 <br />
        <br />
        第二百九十四条　组织、领导和积极参加以暴力、威胁或者其他手段，有组织地进行违法犯罪活动，称霸一方，为非作恶，欺压、残害群众，严重破坏经济、社会生活秩序的黑社会性质的组织的，处三年以上十年以下有期徒刑；其他参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　境外的黑社会组织的人员到中华人民共和国境内发展组织成员的，处三年以上十年以下有期徒刑。
        　　犯前两款罪又有其他犯罪行为的，依照数罪并罚的规定处罚。
        　　国家机关工作人员包庇黑社会性质的组织，或者纵容黑社会性质的组织进行违法犯罪活动的，处三年以下有期徒刑、拘役或者剥夺政治权利；情节严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第二百九十五条　传授犯罪方法的，处五年以下有期徒刑、拘役或者管制；情节严重的，处五年以上有期徒刑；情节特别严重的，处无期徒刑或者死刑。
        　　 <br />
        <br />
        第二百九十六条　举行集会、游行、示威，未依照法律规定申请或者申请未获许可，或者未按照主管机关许可的起止时间、地点、路线进行，又拒不服从解散命令，严重破坏社会秩序的，对集会、游行、示威的负责人和直接责任人员，处五年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第二百九十七条　违反法律规定，携带武器、管制刀具或者爆炸物参加集会、游行、示威的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第二百九十八条　扰乱、冲击或者以其他方法破坏依法举行的集会、游行、示威，造成公共秩序混乱的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第二百九十九条　在公众场合故意以焚烧、毁损、涂划、玷污、践踏等方式侮辱中华人民共和国国旗、国徽的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第三百条　组织和利用会道门、邪教组织或者利用迷信破坏国家法律、行政法规实施的，处三年以上七年以下有期徒刑；情节特别严重的，处七年以上有期徒刑。
        　　组织和利用会道门、邪教组织或者利用迷信蒙骗他人，致人死亡的，依照前款的规定处罚。
        　　组织和利用会道门、邪教组织或者利用迷信奸淫妇女、诈骗财物的，分别依照本法{" "}
        <br />
        <br />
        第二百三十六条、 <br />
        <br />
        第二百六十六条的规定定罪处罚。 　　 <br />
        <br />
        第三百零一条　聚众进行淫乱活动的，对首要分子或者多次参加的，处五年以下有期徒刑、拘役或者管制。
        　　引诱未成年人参加聚众淫乱活动的，依照前款的规定从重处罚。 　　 <br />
        <br />
        第三百零二条　盗窃、侮辱尸体的，处三年以下有期徒刑、拘役或者管制。 　　{" "}
        <br />
        <br />
        第三百零三条　以营利为目的，聚众赌博、开设赌场或者以赌博为业的，处三年以下有期徒刑、拘役或者管制，并处罚金。
        　　 <br />
        <br />
        第三百零四条　邮政工作人员严重不负责任，故意延误投递邮件，致使公共财产、国家和人民利益遭受重大损失的，处二年以下有期徒刑或者拘役。
        <br />
        <br />
        第二节　妨害司法罪 　　 <br />
        <br />
        第三百零五条　在刑事诉讼中，证人、鉴定人、记录人、翻译人对与案件有重要关系的情节，故意作虚假证明、鉴定、记录、翻译，意图陷害他人或者隐匿罪证的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第三百零六条　在刑事诉讼中，辩护人、诉讼代理人毁灭、伪造证据，帮助当事人毁灭、伪造证据，威胁、引诱证人违背事实改变证言或者作伪证的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　辩护人、诉讼代理人提供、出示、引用的证人证言或者其他证据失实，不是有意伪造的，不属于伪造证据。
        　　 <br />
        <br />
        第三百零七条　以暴力、威胁、贿买等方法阻止证人作证或者指使他人作伪证的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　帮助当事人毁灭、伪造证据，情节严重的，处三年以下有期徒刑或者拘役。
        　　司法工作人员犯前两款罪的，从重处罚。 　　 <br />
        <br />
        第三百零八条　对证人进行打击报复的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第三百零九条　聚众哄闹、冲击法庭，或者殴打司法工作人员，严重扰乱法庭秩序的，处三年以下有期徒刑、拘役、管制或者罚金。
        　　 <br />
        <br />
        第三百一十条　明知是犯罪的人而为其提供隐藏处所、财物，帮助其逃匿或者作假证明包庇的，处三年以下有期徒刑、拘役或者管制；情节严重的，处三年以上十年以下有期徒刑。
        　　犯前款罪，事前通谋的，以共同犯罪论处。 　　 <br />
        <br />
        第三百一十一条　明知他人有间谍犯罪行为，在国家安全机关向其调查有关情况、收集有关证据时，拒绝提供，情节严重的，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第三百一十二条　明知是犯罪所得的赃物而予以窝藏、转移、收购或者代为销售的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金。
        　　 <br />
        <br />
        第三百一十三条　对人民法院的判决、裁定有能力执行而拒不执行，情节严重的，处三年以下有期徒刑、拘役或者罚金。
        　　 <br />
        <br />
        第三百一十四条　隐藏、转移、变卖、故意毁损已被司法机关查封、扣押、冻结的财产，情节严重的，处三年以下有期徒刑、拘役或者罚金。
        　　 <br />
        <br />
        第三百一十五条　依法被关押的罪犯，有下列破坏监管秩序行为之一，情节严重的，处三年以下有期徒刑:
        　　 <br />
        <br />
        （一）殴打监管人员的； 　　 <br />
        <br />
        （二）组织其他被监管人破坏监管秩序的； 　　 <br />
        <br />
        （三）聚众闹事，扰乱正常监管秩序的； 　　 <br />
        <br />
        （四）殴打、体罚或者指使他人殴打、体罚其他被监管人的。 　　 <br />
        <br />
        第三百一十六条　依法被关押的罪犯、被告人、犯罪嫌疑人脱逃的，处五年以下有期徒刑或者拘役。
        　　劫夺押解途中的罪犯、被告人、犯罪嫌疑人的，处三年以上七年以下有期徒刑；情节严重的，处七年以上有期徒刑。
        　　 <br />
        <br />
        第三百一十七条　组织越狱的首要分子和积极参加的，处五年以上有期徒刑；其他参加的，处五年以下有期徒刑或者拘役。
        　　暴动越狱或者聚众持械劫狱的首要分子和积极参加的，处十年以上有期徒刑或者无期徒刑；情节特别严重的，处死刑；其他参加的，处三年以上十年以下有期徒刑。
        <br />
        <br />
        第三节　妨害国 <br />
        <br />
        （边）境管理罪 　　 <br />
        <br />
        第三百一十八条　组织他人偷越国 <br />
        <br />
        （边）境的，处二年以上七年以下有期徒刑，并处罚金；有下列情形之一的，处七年以上有期徒刑或者无期徒刑，并处罚金或者没收财产:
        　　 <br />
        <br />
        （一）组织他人偷越国 <br />
        <br />
        （边）境集团的首要分子； 　　 <br />
        <br />
        （二）多次组织他人偷越国 <br />
        <br />
        （边）境或者组织他人偷越国 <br />
        <br />
        （边）境人数众多的； 　　 <br />
        <br />
        （三）造成被组织人重伤、死亡的； 　　 <br />
        <br />
        （四）剥夺或者限制被组织人人身自由的； 　　 <br />
        <br />
        （五）以暴力、威胁方法抗拒检查的； 　　 <br />
        <br />
        （六）违法所得数额巨大的； 　　 <br />
        <br />
        （七）有其他特别严重情节的。
        　　犯前款罪，对被组织人有杀害、伤害、强奸、拐卖等犯罪行为，或者对检查人员有杀害、伤害等犯罪行为的，依照数罪并罚的规定处罚。
        　　 <br />
        <br />
        第三百一十九条　以劳务输出、经贸往来或者其他名义，弄虚作假，骗取护照、签证等出境证件，为组织他人偷越国{" "}
        <br />
        <br />
        （边）境使用的，处三年以下有期徒刑，并处罚金；情节严重的，处三年以上十年以下有期徒刑，并处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百二十条　为他人提供伪造、变造的护照、签证等出入境证件，或者出售护照、签证等出入境证件的，处五年以下有期徒刑，并处罚金；情节严重的，处五年以上有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百二十一条　运送他人偷越国 <br />
        <br />
        （边）境的，处五年以下有期徒刑、拘役或者管制，并处罚金；有下列情形之一的，处五年以上十年以下有期徒刑，并处罚金:
        　　 <br />
        <br />
        （一）多次实施运送行为或者运送人数众多的； 　　 <br />
        <br />
        （二）所使用的船只、车辆等交通工具不具备必要的安全条件，足以造成严重后果的；
        　　 <br />
        <br />
        （三）违法所得数额巨大的； 　　 <br />
        <br />
        （四）有其他特别严重情节的。 　　在运送他人偷越国 <br />
        <br />
        （边）境中造成被运送人重伤、死亡，或者以暴力、威胁方法抗拒检查的，处七年以上有期徒刑，并处罚金。
        　　犯前两款罪，对被运送人有杀害、伤害、强奸、拐卖等犯罪行为，或者对检查人员有杀害、伤害等犯罪行为的，依照数罪并罚的规定处罚。
        　　 <br />
        <br />
        第三百二十二条　违反国 <br />
        <br />
        （边）境管理法规，偷越国 <br />
        <br />
        （边）境，情节严重的，处一年以下有期徒刑、拘役或者管制，并处罚金。 　　{" "}
        <br />
        <br />
        第三百二十三条　故意破坏国家边境的界碑、界桩或者永久性测量标志的，处三年以下有期徒刑或者拘役。
        <br />
        <br />
        第四节　妨害文物管理罪 　　 <br />
        <br />
        第三百二十四条　故意损毁国家保护的珍贵文物或者被确定为全国重点文物保护单位、省级文物保护单位的文物的，处三年以下有期徒刑或者拘役，并处或者单处罚金；情节严重的，处三年以上十年以下有期徒刑，并处罚金。
        　　故意损毁国家保护的名胜古迹，情节严重的，处五年以下有期徒刑或者拘役，并处或者单处罚金。
        　　过失损毁国家保护的珍贵文物或者被确定为全国重点文物保护单位、省级文物保护单位的文物，造成严重后果的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百二十五条　违反文物保护法规，将收藏的国家禁止出口的珍贵文物私自出售或者私自赠送给外国人的，处五年以下有期徒刑或者拘役，可以并处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百二十六条　以牟利为目的，倒卖国家禁止经营的文物，情节严重的，处五年以下有期徒刑或者拘役，并处罚金；情节特别严重的，处五年以上十年以下有期徒刑，并处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百二十七条　违反文物保护法规，国有博物馆、图书馆等单位将国家保护的文物藏品出售或者私自送给非国有单位或者个人的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百二十八条　盗掘具有历史、艺术、科学价值的古文化遗址、古墓葬的，处三年以上十年以下有期徒刑，并处罚金；情节较轻的，处三年以下有期徒刑、拘役或者管制，并处罚金；有下列情形之一的，处十年以上有期徒刑、无期徒刑或者死刑，并处罚金或者没收财产:
        　　 <br />
        <br />
        （一）盗掘确定为全国重点文物保护单位和省级文物保护单位的古文化遗址、古墓葬的；
        　　 <br />
        <br />
        （二）盗掘古文化遗址、古墓葬集团的首要分子； 　　 <br />
        <br />
        （三）多次盗掘古文化遗址、古墓葬的； 　　 <br />
        <br />
        （四）盗掘古文化遗址、古墓葬，并盗窃珍贵文物或者造成珍贵文物严重破坏的。
        　　盗掘国家保护的具有科学价值的古人类化石和古脊椎动物化石的，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百二十九条　抢夺、窃取国家所有的档案的，处五年以下有期徒刑或者拘役。
        　　违反档案法的规定，擅自出卖、转让国家所有的档案，情节严重的，处三年以下有期徒刑或者拘役。
        　　有前两款行为，同时又构成本法规定的其他犯罪的，依照处罚较重的规定定罪处罚。
        <br />
        <br />
        第五节　危害公共卫生罪 　　 <br />
        <br />
        第三百三十条　违反传染病防治法的规定，有下列情形之一，引起甲类传染病传播或者有传播严重危险的，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑:
        　　 <br />
        <br />
        （一）供水单位供应的饮用水不符合国家规定的卫生标准的； 　　 <br />
        <br />
        （二）拒绝按照卫生防疫机构提出的卫生要求，对传染病病原体污染的污水、污物、粪便进行消毒处理的；
        　　 <br />
        <br />
        （三）准许或者纵容传染病病人、病原携带者和疑似传染病病人从事国务院卫生行政部门规定禁止从事的易使该传染病扩散的工作的；
        　　 <br />
        <br />
        （四）拒绝执行卫生防疫机构依照传染病防治法提出的预防、控制措施的。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　甲类传染病的范围，依照《中华人民共和国传染病防治法》和国务院有关规定确定。
        　　 <br />
        <br />
        第三百三十一条　从事实验、保藏、携带、运输传染病菌种、毒种的人员，违反国务院卫生行政部门的有关规定，造成传染病菌种、毒种扩散，后果严重的，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第三百三十二条　违反国境卫生检疫规定，引起检疫传染病传播或者有传播严重危险的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百三十三条　非法组织他人出卖血液的，处五年以下有期徒刑，并处罚金；以暴力、威胁方法强迫他人出卖血液的，处五年以上十年以下有期徒刑，并处罚金。
        　　有前款行为，对他人造成伤害的，依照本法 <br />
        <br />
        第二百三十四条的规定定罪处罚。 　　 <br />
        <br />
        第三百三十四条　非法采集、供应血液或者制作、供应血液制品，不符合国家规定的标准，足以危害人体健康的，处五年以下有期徒刑或者拘役，并处罚金；对人体健康造成严重危害的，处五年以上十年以下有期徒刑，并处罚金；造成特别严重后果的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产。
        　　经国家主管部门批准采集、供应血液或者制作、供应血液制品的部门，不依照规定进行检测或者违背其他操作规定，造成危害他人身体健康后果的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百三十五条　医务人员由于严重不负责任，造成就诊人死亡或者严重损害就诊人身体健康的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百三十六条　未取得医生执业资格的人非法行医，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；严重损害就诊人身体健康的，处三年以上十年以下有期徒刑，并处罚金；造成就诊人死亡的，处十年以上有期徒刑，并处罚金。
        　　未取得医生执业资格的人擅自为他人进行节育复通手术、假节育手术、终止妊娠手术或者摘取宫内节育器，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；严重损害就诊人身体健康的，处三年以上十年以下有期徒刑，并处罚金；造成就诊人死亡的，处十年以上有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百三十七条　违反进出境动植物检疫法的规定，逃避动植物检疫，引起重大动植物疫情的，处三年以下有期徒刑或者拘役，并处或者单处罚金。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        <br />
        <br />
        第六节　破坏环境资源保护罪 　　 <br />
        <br />
        第三百三十八条　违反国家规定，向土地、水体、大气排放、倾倒或者处置有放射性的废物、含传染病病原体的废物、有毒物质或者其他危险废物，造成重大环境污染事故，致使公私财产遭受重大损失或者人身伤亡的严重后果的，处三年以下有期徒刑或者拘役，并处或者单处罚金；后果特别严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百三十九条　违反国家规定，将境外的固体废物进境倾倒、堆放、处置的，处五年以下有期徒刑或者拘役，并处罚金；造成重大环境污染事故，致使公私财产遭受重大损失或者严重危害人体健康的，处五年以上十年以下有期徒刑，并处罚金；后果特别严重的，处十年以上有期徒刑，并处罚金。
        　　未经国务院有关主管部门许可，擅自进口固体废物用作原料，造成重大环境污染事故，致使公私财产遭受重大损失或者严重危害人体健康的，处五年以下有期徒刑或者拘役，并处罚金；后果特别严重的，处五年以上十年以下有期徒刑，并处罚金。
        　　以原料利用为名，进口不能用作原料的固体废物的，依照本法 <br />
        <br />
        第一百五十五条的规定定罪处罚。 　　 <br />
        <br />
        第三百四十条　违反保护水产资源法规，在禁渔区、禁渔期或者使用禁用的工具、方法捕捞水产品，情节严重的，处三年以下有期徒刑、拘役、管制或者罚金。
        　　 <br />
        <br />
        第三百四十一条　非法猎捕、杀害国家重点保护的珍贵、濒危野生动物的，或者非法收购、运输、出售国家重点保护的珍贵、濒危野生动物及其制品的，处五年以下有期徒刑或者拘役，并处罚金；情节严重的，处五年以上十年以下有期徒刑，并处罚金；情节特别严重的，处十年以上有期徒刑，并处罚金或者没收财产。
        　　违反狩猎法规，在禁猎区、禁猎期或者使用禁用的工具、方法进行狩猎，破坏野生动物资源，情节严重的，处三年以下有期徒刑、拘役、管制或者罚金。
        　　 <br />
        <br />
        第三百四十二条　违反土地管理法规，非法占用耕地改作他用，数量较大，造成耕地大量毁坏的，处五年以下有期徒刑或者拘役，并处或者单处罚金。
        　　 <br />
        <br />
        第三百四十三条　违反矿产资源法的规定，未取得采矿许可证擅自采矿的，擅自进入国家规划矿区、对国民经济具有重要价值的矿区和他人矿区范围采矿的，擅自开采国家规定实行保护性开采的特定矿种，经责令停止开采后拒不停止开采，造成矿产资源破坏的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；造成矿产资源严重破坏的，处三年以上七年以下有期徒刑，并处罚金。
        　　违反矿产资源法的规定，采取破坏性的开采方法开采矿产资源，造成矿产资源严重破坏的，处五年以下有期徒刑或者拘役，并处罚金。
        　　 <br />
        <br />
        第三百四十四条　违反森林法的规定，非法采伐、毁坏珍贵树木的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百四十五条　盗伐森林或者其他林木，数量较大的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；数量巨大的，处三年以上七年以下有期徒刑，并处罚金；数量特别巨大的，处七年以上有期徒刑，并处罚金。
        　　违反森林法的规定，滥伐森林或者其他林木，数量较大的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；数量巨大的，处三年以上七年以下有期徒刑，并处罚金。
        　　以牟利为目的，在林区非法收购明知是盗伐、滥伐的林木，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；情节特别严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　盗伐、滥伐国家级自然保护区内的森林或者其他林木的，从重处罚。 　　{" "}
        <br />
        <br />
        第三百四十六条　单位犯本节 <br />
        <br />
        第三百三十八条至 <br />
        <br />
        第三百四十五条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照本节各该条的规定处罚。
        <br />
        <br />
        第七节　走私、贩卖、运输、制造毒品罪 　　 <br />
        <br />
        第三百四十七条　走私、贩卖、运输、制造毒品，无论数量多少，都应当追究刑事责任，予以刑事处罚。
        　　走私、贩卖、运输、制造毒品，有下列情形之一的，处十五年有期徒刑、无期徒刑或者死刑，并处没收财产:
        　　 <br />
        <br />
        （一）走私、贩卖、运输、制造鸦片一千克以上、海洛因或者甲基苯丙胺五十克以上或者其他毒品数量大的；
        　　 <br />
        <br />
        （二）走私、贩卖、运输、制造毒品集团的首要分子； 　　 <br />
        <br />
        （三）武装掩护走私、贩卖、运输、制造毒品的； 　　 <br />
        <br />
        （四）以暴力抗拒检查、拘留、逮捕，情节严重的； 　　 <br />
        <br />
        （五）参与有组织的国际贩毒活动的。
        　　走私、贩卖、运输、制造鸦片二百克以上不满一千克、海洛因或者甲基苯丙胺十克以上不满五十克或者其他毒品数量较大的，处七年以上有期徒刑，并处罚金。
        　　走私、贩卖、运输、制造鸦片不满二百克、海洛因或者甲基苯丙胺不满十克或者其他少量毒品的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　单位犯 <br />
        <br />
        第二款、 <br />
        <br />
        第三款、 <br />
        <br />
        第四款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照各该款的规定处罚。
        　　利用、教唆未成年人走私、贩卖、运输、制造毒品，或者向未成年人出售毒品的，从重处罚。
        　　对多次走私、贩卖、运输、制造毒品，未经处理的，毒品数量累计计算。
        　　 <br />
        <br />
        第三百四十八条　非法持有鸦片一千克以上、海洛因或者甲基苯丙胺五十克以上或者其他毒品数量大的，处七年以上有期徒刑或者无期徒刑，并处罚金；非法持有鸦片二百克以上不满一千克、海洛因或者甲基苯丙胺十克以上不满五十克或者其他毒品数量较大的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百四十九条　包庇走私、贩卖、运输、制造毒品的犯罪分子的，为犯罪分子窝藏、转移、隐瞒毒品或者犯罪所得的财物的，处三年以下有期徒刑、拘役或者管制；情节严重的，处三年以上十年以下有期徒刑。
        　　缉毒人员或者其他国家机关工作人员掩护、包庇走私、贩卖、运输、制造毒品的犯罪分子的，依照前款的规定从重处罚。
        　　犯前两款罪，事先通谋的，以走私、贩卖、运输、制造毒品罪的共犯论处。
        　　 <br />
        <br />
        第三百五十条　违反国家规定，非法运输、携带醋酸酐、乙醚、三氯甲烷或者其他用于制造毒品的原料或者配剂进出境的，或者违反国家规定，在境内非法买卖上述物品的，处三年以下有期徒刑、拘役或者管制，并处罚金；数量大的，处三年以上十年以下有期徒刑，并处罚金。
        　　明知他人制造毒品而为其提供前款规定的物品的，以制造毒品罪的共犯论处。
        　　单位犯前两款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前两款的规定处罚。
        　　 <br />
        <br />
        第三百五十一条　非法种植罂粟、大麻等毒品原植物的，一律强制铲除。有下列情形之一的，处五年以下有期徒刑、拘役或者管制，并处罚金：
        　　 <br />
        <br />
        （一）种植罂粟五百株以上不满三千株或者其他毒品原植物数量较大的； 　　{" "}
        <br />
        <br />
        （二）经公安机关处理后又种植的； 　　 <br />
        <br />
        （三）抗拒铲除的。
        　　非法种植罂粟三千株以上或者其他毒品原植物数量大的，处五年以上有期徒刑，并处罚金或者没收财产。
        　　非法种植罂粟或者其他毒品原植物，在收获前自动铲除的，可以免除处罚。
        　　 <br />
        <br />
        第三百五十二条　非法买卖、运输、携带、持有未经灭活的罂粟等毒品原植物种子或者幼苗，数量较大的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金。
        　　 <br />
        <br />
        第三百五十三条　引诱、教唆、欺骗他人吸食、注射毒品的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。
        　　强迫他人吸食、注射毒品的，处三年以上十年以下有期徒刑，并处罚金。
        　　引诱、教唆、欺骗或者强迫未成年人吸食、注射毒品的，从重处罚。 　　{" "}
        <br />
        <br />
        第三百五十四条　容留他人吸食、注射毒品的，处三年以下有期徒刑、拘役或者管制，并处罚金。
        　　 <br />
        <br />
        第三百五十五条　依法从事生产、运输、管理、使用国家管制的麻醉药品、精神药品的人员，违反国家规定，向吸食、注射毒品的人提供国家规定管制的能够使人形成瘾癖的麻醉药品、精神药品的，处三年以下有期徒刑或者拘役，并处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。向走私、贩卖毒品的犯罪分子或者以牟利为目的，向吸食、注射毒品的人提供国家规定管制的能够使人形成瘾癖的麻醉药品、精神药品的，依照本法{" "}
        <br />
        <br />
        第三百四十七条的规定定罪处罚。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百五十六条　因走私、贩卖、运输、制造、非法持有毒品罪被判过刑，又犯本节规定之罪的，从重处罚。
        　　 <br />
        <br />
        第三百五十七条　本法所称的毒品，是指鸦片、海洛因、甲基苯丙胺 <br />
        <br />
        （冰毒）、吗啡、大麻、可卡因以及国家规定管制的其他能够使人形成瘾癖的麻醉药品和精神药品。
        　　毒品的数量以查证属实的走私、贩卖、运输、制造、非法持有毒品的数量计算，不以纯度折算。
        <br />
        <br />
        第八节　组织、强迫、引诱、容留、介绍卖淫罪 　　 <br />
        <br />
        第三百五十八条　组织他人卖淫或者强迫他人卖淫的，处五年以上十年以下有期徒刑，并处罚金；有下列情形之一的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产：
        　　 <br />
        <br />
        （一）组织他人卖淫，情节严重的； 　　 <br />
        <br />
        （二）强迫不满十四周岁的幼女卖淫的； 　　 <br />
        <br />
        （三）强迫多人卖淫或者多次强迫他人卖淫的； 　　 <br />
        <br />
        （四）强奸后迫使卖淫的； 　　 <br />
        <br />
        （五）造成被强迫卖淫的人重伤、死亡或者其他严重后果的。
        　　有前款所列情形之一，情节特别严重的，处无期徒刑或者死刑，并处没收财产。
        　　协助组织他人卖淫的，处五年以下有期徒刑，并处罚金；情节严重的，处五年以上十年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百五十九条　引诱、容留、介绍他人卖淫的，处五年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处五年以上有期徒刑，并处罚金。
        　　引诱不满十四周岁的幼女卖淫的，处五年以上有期徒刑，并处罚金。 　　{" "}
        <br />
        <br />
        第三百六十条　明知自己患有梅毒、淋病等严重性病卖淫、嫖娼的，处五年以下有期徒刑、拘役或者管制，并处罚金。
        　　嫖宿不满十四周岁的幼女的，处五年以上有期徒刑，并处罚金。 　　 <br />
        <br />
        第三百六十一条　旅馆业、饮食服务业、文化娱乐业、出租汽车业等单位的人员，利用本单位的条件，组织、强迫、引诱、容留、介绍他人卖淫的，依照本法{" "}
        <br />
        <br />
        第三百五十八条、 <br />
        <br />
        第三百五十九条的规定定罪处罚。
        　　前款所列单位的主要负责人，犯前款罪的，从重处罚。 　　 <br />
        <br />
        第三百六十二条　旅馆业、饮食服务业、文化娱乐业、出租汽车业等单位的人员，在公安机关查处卖淫、嫖娼活动时，为违法犯罪分子通风报信，情节严重的，依照本法{" "}
        <br />
        <br />
        第三百一十条的规定定罪处罚。
        <br />
        <br />
        第九节　制作、贩卖、传播淫秽物品罪 　　 <br />
        <br />
        第三百六十三条　以牟利为目的，制作、复制、出版、贩卖、传播淫秽物品的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上十年以下有期徒刑，并处罚金；情节特别严重的，处十年以上有期徒刑或者无期徒刑，并处罚金或者没收财产。
        　　为他人提供书号，出版淫秽书刊的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金；明知他人用于出版淫秽书刊而提供书号的，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百六十四条　传播淫秽的书刊、影片、音像、图片或者其他淫秽物品，情节严重的，处二年以下有期徒刑、拘役或者管制。
        　　组织播放淫秽的电影、录像等音像制品的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上十年以下有期徒刑，并处罚金。
        　　制作、复制淫秽的电影、录像等音像制品组织播放的，依照 <br />
        <br />
        第二款的规定从重处罚。
        　　向不满十八周岁的未成年人传播淫秽物品的，从重处罚。 　　 <br />
        <br />
        第三百六十五条　组织进行淫秽表演的，处三年以下有期徒刑、拘役或者管制，并处罚金；情节严重的，处三年以上十年以下有期徒刑，并处罚金。
        　　 <br />
        <br />
        第三百六十六条　单位犯本节 <br />
        <br />
        第三百六十三条、 <br />
        <br />
        第三百六十四条、 <br />
        <br />
        第三百六十五条规定之罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照各该条的规定处罚。
        　　 <br />
        <br />
        第三百六十七条　本法所称淫秽物品，是指具体描绘性行为或者露骨宣扬色情的诲淫性的书刊、影片、录像带、录音带、图片及其他淫秽物品。
        　　有关人体生理、医学知识的科学著作不是淫秽物品。
        　　包含有色情内容的有艺术价值的文学、艺术作品不视为淫秽物品。
        <br />
        <br />
        第七章　危害国防利益罪 　　 <br />
        <br />
        第三百六十八条　以暴力、威胁方法阻碍军人依法执行职务的，处三年以下有期徒刑、拘役、管制或者罚金。
        　　故意阻碍武装部队军事行动，造成严重后果的，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百六十九条　破坏武器装备、军事设施、军事通信的，处三年以下有期徒刑、拘役或者管制；破坏重要武器装备、军事设施、军事通信的，处三年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑、无期徒刑或者死刑。战时从重处罚。
        　　 <br />
        <br />
        第三百七十条　明知是不合格的武器装备、军事设施而提供给武装部队的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　过失犯前款罪，造成严重后果的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上七年以下有期徒刑。
        　　单位犯 <br />
        <br />
        第一款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照{" "}
        <br />
        <br />
        第一款的规定处罚。 　　 <br />
        <br />
        第三百七十一条　聚众冲击军事禁区，严重扰乱军事禁区秩序的，对首要分子，处五年以上十年以下有期徒刑；对其他积极参加的，处五年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　聚众扰乱军事管理区秩序，情节严重，致使军事管理区工作无法进行，造成严重损失的，对首要分子，处三年以上七年以下有期徒刑；对其他积极参加的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利。
        　　 <br />
        <br />
        第三百七十二条　冒充军人招摇撞骗的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第三百七十三条　煽动军人逃离部队或者明知是逃离部队的军人而雇用，情节严重的，处三年以下有期徒刑、拘役或者管制。
        　　 <br />
        <br />
        第三百七十四条　在征兵工作中徇私舞弊，接送不合格兵员，情节严重的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第三百七十五条　伪造、变造、买卖或者盗窃、抢夺武装部队公文、证件、印章的，处三年以下有期徒刑、拘役、管制或者剥夺政治权利；情节严重的，处三年以上十年以下有期徒刑。
        　　非法生产、买卖武装部队制式服装、车辆号牌等专用标志，情节严重的，处三年以下有期徒刑、拘役或者管制，并处或者单处罚金。
        　　单位犯 <br />
        <br />
        第二款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照该款的规定处罚。
        　　 <br />
        <br />
        第三百七十六条　预备役人员战时拒绝、逃避征召或者军事训练，情节严重的，处三年以下有期徒刑或者拘役。
        　　公民战时拒绝、逃避服役，情节严重的，处二年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百七十七条　战时故意向武装部队提供虚假敌情，造成严重后果的，处三年以上十年以下有期徒刑；造成特别严重后果的，处十年以上有期徒刑或者无期徒刑。
        　　 <br />
        <br />
        第三百七十八条　战时造谣惑众，扰乱军心的，处三年以下有期徒刑、拘役或者管制；情节严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第三百七十九条　战时明知是逃离部队的军人而为其提供隐蔽处所、财物，情节严重的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第三百八十条　战时拒绝或者故意延误军事订货，情节严重的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役；造成严重后果的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第三百八十一条　战时拒绝军事征收、征用，情节严重的，处三年以下有期徒刑或者拘役。
        <br />
        <br />
        第八章　贪污贿赂罪 　　 <br />
        <br />
        第三百八十二条　国家工作人员利用职务上的便利，侵吞、窃取、骗取或者以其他手段非法占有公共财物的，是贪污罪。
        　　受国家机关、国有公司、企业、事业单位、人民团体委托管理、经营国有财产的人员，利用职务上的便利，侵吞、窃取、骗取或者以其他手段非法占有国有财物的，以贪污论。
        　　与前两款所列人员勾结，伙同贪污的，以共犯论处。 　　 <br />
        <br />
        第三百八十三条　对犯贪污罪的，根据情节轻重，分别依照下列规定处罚： 　　{" "}
        <br />
        <br />
        （一）个人贪污数额在十万元以上的，处十年以上有期徒刑或者无期徒刑，可以并处没收财产；情节特别严重的，处死刑，并处没收财产。
        　　 <br />
        <br />
        （二）个人贪污数额在五万元以上不满十万元的，处五年以上有期徒刑，可以并处没收财产；情节特别严重的，处无期徒刑，并处没收财产。
        　　 <br />
        <br />
        （三）个人贪污数额在五千元以上不满五万元的，处一年以上七年以下有期徒刑；情节严重的，处七年以上十年以下有期徒刑。个人贪污数额在五千元以上不满一万元，犯罪后有悔改表现、积极退赃的，可以减轻处罚或者免予刑事处罚，由其所在单位或者上级主管机关给予行政处分。
        　　 <br />
        <br />
        （四）个人贪污数额不满五千元，情节较重的，处二年以下有期徒刑或者拘役；情节较轻的，由其所在单位或者上级主管机关酌情给予行政处分。
        　　对多次贪污未经处理的，按照累计贪污数额处罚。 　　 <br />
        <br />
        第三百八十四条　国家工作人员利用职务上的便利，挪用公款归个人使用，进行非法活动的，或者挪用公款数额较大、进行营利活动的，或者挪用公款数额较大、超过三个月未还的，是挪用公款罪，处五年以下有期徒刑或者拘役；情节严重的，处五年以上有期徒刑。挪用公款数额巨大不退还的，处十年以上有期徒刑或者无期徒刑。
        　　挪用用于救灾、抢险、防汛、优抚、扶贫、移民、救济款物归个人使用的，从重处罚。
        　　 <br />
        <br />
        第三百八十五条　国家工作人员利用职务上的便利，索取他人财物的，或者非法收受他人财物，为他人谋取利益的，是受贿罪。
        　　国家工作人员在经济往来中，违反国家规定，收受各种名义的回扣、手续费，归个人所有的，以受贿论处。
        　　 <br />
        <br />
        第三百八十六条　对犯受贿罪的，根据受贿所得数额及情节，依照本法 <br />
        <br />
        第三百八十三条的规定处罚。索贿的从重处罚。 　　 <br />
        <br />
        第三百八十七条　国家机关、国有公司、企业、事业单位、人民团体，索取、非法收受他人财物，为他人谋取利益，情节严重的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。
        　　前款所列单位，在经济往来中，在帐外暗中收受各种名义的回扣、手续费的，以受贿论，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百八十八条　国家工作人员利用本人职权或者地位形成的便利条件，通过其他国家工作人员职务上的行为，为请托人谋取不正当利益，索取请托人财物或者收受请托人财物的，以受贿论处。
        　　 <br />
        <br />
        第三百八十九条　为谋取不正当利益，给予国家工作人员以财物的，是行贿罪。
        　　在经济往来中，违反国家规定，给予国家工作人员以财物，数额较大的，或者违反国家规定，给予国家工作人员以各种名义的回扣、手续费的，以行贿论处。
        　　因被勒索给予国家工作人员以财物，没有获得不正当利益的，不是行贿。
        　　 <br />
        <br />
        第三百九十条　对犯行贿罪的，处五年以下有期徒刑或者拘役；因行贿谋取不正当利益，情节严重的，或者使国家利益遭受重大损失的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑或者无期徒刑，可以并处没收财产。
        　　行贿人在被追诉前主动交待行贿行为的，可以减轻处罚或者免除处罚。 　　{" "}
        <br />
        <br />
        第三百九十一条　为谋取不正当利益，给予国家机关、国有公司、企业、事业单位、人民团体以财物的，或者在经济往来中，违反国家规定，给予各种名义的回扣、手续费的，处三年以下有期徒刑或者拘役。
        　　单位犯前款罪的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第三百九十二条　向国家工作人员介绍贿赂，情节严重的，处三年以下有期徒刑或者拘役。
        　　介绍贿赂人在被追诉前主动交待介绍贿赂行为的，可以减轻处罚或者免除处罚。
        　　 <br />
        <br />
        第三百九十三条　单位为谋取不正当利益而行贿，或者违反国家规定，给予国家工作人员以回扣、手续费，情节严重的，对单位判处罚金，并对其直接负责的主管人员和其他直接责任人员，处五年以下有期徒刑或者拘役。因行贿取得的违法所得归个人所有的，依照本法{" "}
        <br />
        <br />
        第三百八十九条、 <br />
        <br />
        第三百九十条的规定定罪处罚。 　　 <br />
        <br />
        第三百九十四条　国家工作人员在国内公务活动或者对外交往中接受礼物，依照国家规定应当交公而不交公，数额较大的，依照本法{" "}
        <br />
        <br />
        第三百八十二条、 <br />
        <br />
        第三百八十三条的规定定罪处罚。 　　 <br />
        <br />
        第三百九十五条　国家工作人员的财产或者支出明显超过合法收入，差额巨大的，可以责令说明来源。本人不能说明其来源是合法的，差额部分以非法所得论，处五年以下有期徒刑或者拘役，财产的差额部分予以追缴。
        　　国家工作人员在境外的存款，应当依照国家规定申报。数额较大、隐瞒不报的，处二年以下有期徒刑或者拘役；情节较轻的，由其所在单位或者上级主管机关酌情给予行政处分。
        　　 <br />
        <br />
        第三百九十六条　国家机关、国有公司、企业、事业单位、人民团体，违反国家规定，以单位名义将国有资产集体私分给个人，数额较大的，对其直接负责的主管人员和其他直接责任人员，处三年以下有期徒刑或者拘役，并处或者单处罚金；数额巨大的，处三年以上七年以下有期徒刑，并处罚金。
        　　司法机关、行政执法机关违反国家规定，将应当上缴国家的罚没财物，以单位名义集体私分给个人的，依照前款的规定处罚。
        <br />
        <br />
        第九章　渎职罪 　　 <br />
        <br />
        第三百九十七条　国家机关工作人员滥用职权或者玩忽职守，致使公共财产、国家和人民利益遭受重大损失的，处三年以下有期徒刑或者拘役；情节特别严重的，处三年以上七年以下有期徒刑。本法另有规定的，依照规定。
        　　国家机关工作人员徇私舞弊，犯前款罪的，处五年以下有期徒刑或者拘役；情节特别严重的，处五年以上十年以下有期徒刑。本法另有规定的，依照规定。
        　　 <br />
        <br />
        第三百九十八条　国家机关工作人员违反保守国家秘密法的规定，故意或者过失泄露国家秘密，情节严重的，处三年以下有期徒刑或者拘役；情节特别严重的，处三年以上七年以下有期徒刑。
        　　非国家机关工作人员犯前款罪的，依照前款的规定酌情处罚。 　　 <br />
        <br />
        第三百九十九条　司法工作人员徇私枉法、徇情枉法，对明知是无罪的人而使他受追诉、对明知是有罪的人而故意包庇不使他受追诉，或者在刑事审判活动中故意违背事实和法律作枉法裁判的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑。
        　　在民事、行政审判活动中故意违背事实和法律作枉法裁判，情节严重的，处五年以下有期徒刑或者拘役；情节特别严重的，处五年以上十年以下有期徒刑。
        　　司法工作人员贪赃枉法，有前两款行为的，同时又构成本法 <br />
        <br />
        第三百八十五条规定之罪的，依照处罚较重的规定定罪处罚。 　　 <br />
        <br />
        第四百条　司法工作人员私放在押的犯罪嫌疑人、被告人或者罪犯的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑。
        　　司法工作人员由于严重不负责任，致使在押的犯罪嫌疑人、被告人或者罪犯脱逃，造成严重后果的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第四百零一条　司法工作人员徇私舞弊，对不符合减刑、假释、暂予监外执行条件的罪犯，予以减刑、假释或者暂予监外执行的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百零二条　行政执法人员徇私舞弊，对依法应当移交司法机关追究刑事责任的不移交，情节严重的，处三年以下有期徒刑或者拘役；造成严重后果的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百零三条　国家有关主管部门的国家机关工作人员，徇私舞弊，滥用职权，对不符合法律规定条件的公司设立、登记申请或者股票、债券发行、上市申请，予以批准或者登记，致使公共财产、国家和人民利益遭受重大损失的，处五年以下有期徒刑或者拘役。
        　　上级部门强令登记机关及其工作人员实施前款行为的，对其直接负责的主管人员，依照前款的规定处罚。
        　　 <br />
        <br />
        第四百零四条　税务机关的工作人员徇私舞弊，不征或者少征应征税款，致使国家税收遭受重大损失的，处五年以下有期徒刑或者拘役；造成特别重大损失的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百零五条　税务机关的工作人员违反法律、行政法规的规定，在办理发售发票、抵扣税款、出口退税工作中，徇私舞弊，致使国家利益遭受重大损失的，处五年以下有期徒刑或者拘役；致使国家利益遭受特别重大损失的，处五年以上有期徒刑。
        　　其他国家机关工作人员违反国家规定，在提供出口货物报关单、出口收汇核销单等出口退税凭证的工作中，徇私舞弊，致使国家利益遭受重大损失的，依照前款的规定处罚。
        　　 <br />
        <br />
        第四百零六条　国家机关工作人员在签订、履行合同过程中，因严重不负责任被诈骗，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役；致使国家利益遭受特别重大损失的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百零七条　林业主管部门的工作人员违反森林法的规定，超过批准的年采伐限额发放林木采伐许可证或者违反规定滥发林木采伐许可证，情节严重，致使森林遭受严重破坏的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百零八条　负有环境保护监督管理职责的国家机关工作人员严重不负责任，导致发生重大环境污染事故，致使公私财产遭受重大损失或者造成人身伤亡的严重后果的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百零九条　从事传染病防治的政府卫生行政部门的工作人员严重不负责任，导致传染病传播或者流行，情节严重的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十条　国家机关工作人员徇私舞弊，违反土地管理法规，滥用职权，非法批准征收、征用、占用土地，或者非法低价出让国有土地使用权，情节严重的，处三年以下有期徒刑或者拘役；致使国家或者集体利益遭受特别重大损失的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百一十一条　海关工作人员徇私舞弊，放纵走私，情节严重的，处五年以下有期徒刑或者拘役；情节特别严重的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百一十二条　国家商检部门、商检机构的工作人员徇私舞弊，伪造检验结果的，处五年以下有期徒刑或者拘役；造成严重后果的，处五年以上十年以下有期徒刑。
        　　前款所列人员严重不负责任，对应当检验的物品不检验，或者延误检验出证、错误出证，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十三条　动植物检疫机关的检疫人员徇私舞弊，伪造检疫结果的，处五年以下有期徒刑或者拘役；造成严重后果的，处五年以上十年以下有期徒刑。
        　　前款所列人员严重不负责任，对应当检疫的检疫物不检疫，或者延误检疫出证、错误出证，致使国家利益遭受重大损失的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十四条　对生产、销售伪劣商品犯罪行为负有追究责任的国家机关工作人员，徇私舞弊，不履行法律规定的追究职责，情节严重的，处五年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十五条　负责办理护照、签证以及其他出入境证件的国家机关工作人员，对明知是企图偷越国{" "}
        <br />
        <br />
        （边）境的人员，予以办理出入境证件的，或者边防、海关等国家机关工作人员，对明知是偷越国（边）境的人员，予以放行的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百一十六条　对被拐卖、绑架的妇女、儿童负有解救职责的国家机关工作人员，接到被拐卖、绑架的妇女、儿童及其家属的解救要求或者接到其他人的举报，而对被拐卖、绑架的妇女、儿童不进行解救，造成严重后果的，处五年以下有期徒刑或者拘役。
        　　负有解救职责的国家机关工作人员利用职务阻碍解救的，处二年以上七年以下有期徒刑；情节较轻的，处二年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十七条　有查禁犯罪活动职责的国家机关工作人员，向犯罪分子通风报信、提供便利，帮助犯罪分子逃避处罚的，处三年以下有期徒刑或者拘役；情节严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第四百一十八条　国家机关工作人员在招收公务员、学生工作中徇私舞弊，情节严重的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百一十九条　国家机关工作人员严重不负责任，造成珍贵文物损毁或者流失，后果严重的，处三年以下有期徒刑或者拘役。
        <br />
        <br />
        第十章　军人违反职责罪 　　 <br />
        <br />
        第四百二十条　军人违反职责，危害国家军事利益，依照法律应当受刑罚处罚的行为，是军人违反职责罪。
        　　 <br />
        <br />
        第四百二十一条　战时违抗命令，对作战造成危害的，处三年以上十年以下有期徒刑；致使战斗、战役遭受重大损失的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百二十二条　故意隐瞒、谎报军情或者拒传、假传军令，对作战造成危害的，处三年以上十年以下有期徒刑；致使战斗、战役遭受重大损失的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百二十三条　在战场上贪生怕死，自动放下武器投降敌人的，处三年以上十年以下有期徒刑；情节严重的，处十年以上有期徒刑或者无期徒刑。
        　　投降后为敌人效劳的，处十年以上有期徒刑、无期徒刑或者死刑。 　　{" "}
        <br />
        <br />
        第四百二十四条　战时临阵脱逃的，处三年以下有期徒刑；情节严重的，处三年以上十年以下有期徒刑；致使战斗、战役遭受重大损失的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百二十五条　指挥人员和值班、值勤人员擅离职守或者玩忽职守，造成严重后果的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上七年以下有期徒刑。
        　　战时犯前款罪的，处五年以上有期徒刑。 　　 <br />
        <br />
        第四百二十六条　以暴力、威胁方法，阻碍指挥人员或者值班、值勤人员执行职务的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上有期徒刑；致人重伤、死亡的，或者有其他特别严重情节的，处无期徒刑或者死刑。战时从重处罚。
        　　 <br />
        <br />
        第四百二十七条　滥用职权，指使部属进行违反职责的活动，造成严重后果的，处五年以下有期徒刑或者拘役；情节特别严重的，处五年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第四百二十八条　指挥人员违抗命令，临阵畏缩，作战消极，造成严重后果的，处五年以下有期徒刑；致使战斗、战役遭受重大损失或者有其他特别严重情节的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百二十九条　在战场上明知友邻部队处境危急请求救援，能救援而不救援，致使友邻部队遭受重大损失的，对指挥人员，处五年以下有期徒刑。
        　　 <br />
        <br />
        第四百三十条　在履行公务期间，擅离岗位，叛逃境外或者在境外叛逃，危害国家军事利益的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上有期徒刑。
        　　驾驶航空器、舰船叛逃的，或者有其他特别严重情节的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百三十一条　以窃取、刺探、收买方法，非法获取军事秘密的，处五年以下有期徒刑；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑。
        　　为境外的机构、组织、人员窃取、刺探、收买、非法提供军事秘密的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百三十二条　违反保守国家秘密法规，故意或者过失泄露军事秘密，情节严重的，处五年以下有期徒刑或者拘役；情节特别严重的，处五年以上十年以下有期徒刑。
        　　战时犯前款罪的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑或者无期徒刑。
        　　 <br />
        <br />
        第四百三十三条　战时造谣惑众，动摇军心的，处三年以下有期徒刑；情节严重的，处三年以上十年以下有期徒刑。
        　　勾结敌人造谣惑众，动摇军心的，处十年以上有期徒刑或者无期徒刑；情节特别严重的，可以判处死刑。
        　　 <br />
        <br />
        第四百三十四条　战时自伤身体，逃避军事义务的，处三年以下有期徒刑；情节严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百三十五条　违反兵役法规，逃离部队，情节严重的，处三年以下有期徒刑或者拘役。
        　　战时犯前款罪的，处三年以上七年以下有期徒刑。 　　 <br />
        <br />
        第四百三十六条　违反武器装备使用规定，情节严重，因而发生责任事故，致人重伤、死亡或者造成其他严重后果的，处三年以下有期徒刑或者拘役；后果特别严重的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百三十七条　违反武器装备管理规定，擅自改变武器装备的编配用途，造成严重后果的，处三年以下有期徒刑或者拘役；造成特别严重后果的，处三年以上七年以下有期徒刑。
        　　 <br />
        <br />
        第四百三十八条　盗窃、抢夺武器装备或者军用物资的，处五年以下有期徒刑或者拘役；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　盗窃、抢夺枪支、弹药、爆炸物的，依照本法 <br />
        <br />
        第一百二十七条的规定处罚。 　　 <br />
        <br />
        第四百三十九条　非法出卖、转让军队武器装备的，处三年以上十年以下有期徒刑；出卖、转让大量武器装备或者有其他特别严重情节的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百四十条　违抗命令，遗弃武器装备的，处五年以下有期徒刑或者拘役；遗弃重要或者大量武器装备的，或者有其他严重情节的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百四十一条　遗失武器装备，不及时报告或者有其他严重情节的，处三年以下有期徒刑或者拘役。
        　　 <br />
        <br />
        第四百四十二条　违反规定，擅自出卖、转让军队房地产，情节严重的，对直接责任人员，处三年以下有期徒刑或者拘役；情节特别严重的，处三年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第四百四十三条　滥用职权，虐待部属，情节恶劣，致人重伤或者造成其他严重后果的，处五年以下有期徒刑或者拘役；致人死亡的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百四十四条　在战场上故意遗弃伤病军人，情节恶劣的，对直接责任人员，处五年以下有期徒刑。
        　　 <br />
        <br />
        第四百四十五条　战时在救护治疗职位上，有条件救治而拒不救治危重伤病军人的，处五年以下有期徒刑或者拘役；造成伤病军人重残、死亡或者有其他严重情节的，处五年以上十年以下有期徒刑。
        　　 <br />
        <br />
        第四百四十六条　战时在军事行动地区，残害无辜居民或者掠夺无辜居民财物的，处五年以下有期徒刑；情节严重的，处五年以上十年以下有期徒刑；情节特别严重的，处十年以上有期徒刑、无期徒刑或者死刑。
        　　 <br />
        <br />
        第四百四十七条　私放俘虏的，处五年以下有期徒刑；私放重要俘虏、私放俘虏多人或者有其他严重情节的，处五年以上有期徒刑。
        　　 <br />
        <br />
        第四百四十八条　虐待俘虏，情节恶劣的，处三年以下有期徒刑。 　　 <br />
        <br />
        第四百四十九条　在战时，对被判处三年以下有期徒刑没有现实危险宣告缓刑的犯罪军人，允许其戴罪立功，确有立功表现时，可以撤销原判刑罚，不以犯罪论处。
        　　 <br />
        <br />
        第四百五十条　本章适用于中国人民解放军的现役军官、文职干部、士兵及具有军籍的学员和中国人民武装警察部队的现役警官、文职干部、士兵及具有军籍的学员以及执行军事任务的预备役人员和其他人员。
        　　 <br />
        <br />
        第四百五十一条　本章所称战时，是指国家宣布进入战争状态、部队受领作战任务或者遭敌突然袭击时。
        　　部队执行戒严任务或者处置突发性暴力事件时，以战时论。 附则 　　{" "}
        <br />
        <br />
        第四百五十二条　本法自1997年10月1日起施行。
        　　列于本法附件一的全国人民代表大会常务委员会制定的条例、补充规定和决定，已纳入本法或者已不适用，自本法施行之日起，予以废止。
        　　列于本法附件二的全国人民代表大会常务委员会制定的补充规定和决定予以保留。其中，有关行政处罚和行政措施的规定继续有效；有关刑事责任的规定已纳入本法，自本法施行之日起，适用本法规定。
        附件一：
        　　全国人民代表大会常务委员会制定的下列条例、补充规定和决定，已纳入本法或者已不适用，自本法施行之日起，予以废止：
        　　1.中华人民共和国惩治军人违反职责罪暂行条例
        　　2.关于严惩严重破坏经济的罪犯的决定
        　　3.关于严惩严重危害社会治安的犯罪分子的决定
        　　4.关于惩治走私罪的补充规定 　　5.关于惩治贪污罪贿赂罪的补充规定
        　　6.关于惩治泄露国家秘密犯罪的补充规定
        　　7.关于惩治捕杀国家重点保护的珍贵、濒危野生动物犯罪的补充规定
        　　8.关于惩治侮辱中华人民共和国国旗国徽罪的决定
        　　9.关于惩治盗掘古文化遗址古墓葬犯罪的补充规定
        　　10.关于惩治劫持航空器犯罪分子的决定
        　　11.关于惩治假冒注册商标犯罪的补充规定
        　　12.关于惩治生产、销售伪劣商品犯罪的决定
        　　13.关于惩治侵犯著作权的犯罪的决定
        　　14.关于惩治违反公司法的犯罪的决定
        　　15.关于处理逃跑或者重新犯罪的劳改犯和劳教人员的决定 附件二：
        　　全国人民代表大会常务委员会制定的下列补充规定和决定予以保留，其中，有关行政处罚和行政措施的规定继续有效；有关刑事责任的规定已纳入本法，自本法施行之日起，适用本法规定：
        　　1.关于禁毒的决定
        　　2.关于惩治走私、制作、贩卖、传播淫秽物品的犯罪分子的决定
        　　3.关于严禁卖淫嫖娼的决定
        　　4.关于严惩拐卖、绑架妇女、儿童的犯罪分子的决定
        　　5.关于惩治偷税、抗税犯罪的补充规定
        　　6.关于严惩组织、运送他人偷越国(边)境犯罪的补充规定
        　　7.关于惩治破坏金融秩序犯罪的决定
        　　8.关于惩治虚开、伪造和非法出售增值税专用发票犯罪的决定
      </div>
      <br />
    </div>
  );
};
